var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { id: "preview" } },
    [
      _c(
        "v-alert",
        {
          directives: [
            { name: "show", rawName: "v-show", value: true, expression: "true" }
          ],
          attrs: { color: "primary", value: "true", outline: "" }
        },
        [
          _vm._v("\n    " + _vm._s(_vm.$t("previewAlert")) + " "),
          _c("code", [
            _vm._v(_vm._s(_vm.$store.state._Sites.siteSelected.LIC_URL))
          ]),
          _vm._v(". " + _vm._s(_vm.$t("previewAlert2")) + " \n  ")
        ]
      ),
      _vm._v(" "),
      _vm.loadingGet
        ? _c(
            "div",
            { staticClass: "text-xs-center" },
            [
              _c("v-progress-circular", {
                staticClass: "primary--text",
                attrs: { indeterminate: "", size: 100, width: 1 }
              })
            ],
            1
          )
        : _c(
            "div",
            [
              _c(
                "v-layout",
                { attrs: { row: "", wrap: "" } },
                [
                  _c(
                    "v-flex",
                    { attrs: { xs12: "", md6: "" } },
                    [
                      _c(
                        "v-expansion-panel",
                        [
                          _c(
                            "v-expansion-panel-content",
                            [
                              _c(
                                "div",
                                { attrs: { slot: "header" }, slot: "header" },
                                [
                                  _c(
                                    "v-icon",
                                    { staticClass: "mr-2 primary--text" },
                                    [_vm._v("color_lens")]
                                  ),
                                  _vm._v(
                                    "\n              " +
                                      _vm._s(_vm.$t("previewPerson")) +
                                      "\n            "
                                  )
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "v-card",
                                { staticClass: "ml-3" },
                                [
                                  _c(
                                    "v-expansion-panel",
                                    [
                                      _c(
                                        "v-expansion-panel-content",
                                        {
                                          attrs: {
                                            disabled: _vm.testBrideStatus(
                                              "parametre_apercu_couleurs"
                                            )
                                          }
                                        },
                                        [
                                          _c(
                                            "div",
                                            {
                                              attrs: { slot: "header" },
                                              slot: "header"
                                            },
                                            [
                                              _c(
                                                "v-icon",
                                                {
                                                  staticClass:
                                                    "mr-2 primary--text"
                                                },
                                                [_vm._v("color_lens")]
                                              ),
                                              _vm._v(
                                                "\n                  " +
                                                  _vm._s(
                                                    _vm._f("cap")(
                                                      _vm.$tc("colors", 2, {
                                                        count: ""
                                                      })
                                                    )
                                                  ) +
                                                  "\n                  "
                                              ),
                                              _c("code", [
                                                _vm._v(_vm._s(_vm.color.text))
                                              ])
                                            ],
                                            1
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "v-card",
                                            [
                                              _c(
                                                "v-card-text",
                                                [
                                                  _c(
                                                    "v-container",
                                                    {
                                                      attrs: {
                                                        "grid-list-xl": ""
                                                      }
                                                    },
                                                    [
                                                      _c(
                                                        "v-layout",
                                                        { attrs: { row: "" } },
                                                        [
                                                          _c(
                                                            "v-flex",
                                                            {
                                                              staticClass:
                                                                "xs12"
                                                            },
                                                            [
                                                              _c("v-select", {
                                                                attrs: {
                                                                  dense: "",
                                                                  label: _vm._f(
                                                                    "cap"
                                                                  )(
                                                                    _vm.$t(
                                                                      "colorShemes"
                                                                    )
                                                                  ),
                                                                  items:
                                                                    _vm.colors2019,
                                                                  "return-object":
                                                                    "",
                                                                  box: "",
                                                                  "menu-props":
                                                                    "auto"
                                                                },
                                                                on: {
                                                                  input: function(
                                                                    $event
                                                                  ) {
                                                                    return _vm.updateColors2019()
                                                                  }
                                                                },
                                                                scopedSlots: _vm._u(
                                                                  [
                                                                    {
                                                                      key:
                                                                        "selection",
                                                                      fn: function(
                                                                        data
                                                                      ) {
                                                                        return [
                                                                          _c(
                                                                            "v-list-tile-action",
                                                                            [
                                                                              _c(
                                                                                "v-icon",
                                                                                {
                                                                                  style:
                                                                                    "color: #" +
                                                                                    data
                                                                                      .item
                                                                                      .colors[0] +
                                                                                    "!important",
                                                                                  attrs: {
                                                                                    left:
                                                                                      ""
                                                                                  }
                                                                                },
                                                                                [
                                                                                  _vm._v(
                                                                                    "color_lens"
                                                                                  )
                                                                                ]
                                                                              )
                                                                            ],
                                                                            1
                                                                          ),
                                                                          _vm._v(
                                                                            " "
                                                                          ),
                                                                          _c(
                                                                            "v-list-tile-content",
                                                                            [
                                                                              _c(
                                                                                "div",
                                                                                {
                                                                                  domProps: {
                                                                                    textContent: _vm._s(
                                                                                      data
                                                                                        .item
                                                                                        .text
                                                                                    )
                                                                                  }
                                                                                }
                                                                              )
                                                                            ]
                                                                          )
                                                                        ]
                                                                      }
                                                                    },
                                                                    {
                                                                      key:
                                                                        "item",
                                                                      fn: function(
                                                                        data
                                                                      ) {
                                                                        return [
                                                                          _c(
                                                                            "v-list-tile-action",
                                                                            [
                                                                              _c(
                                                                                "v-icon",
                                                                                {
                                                                                  style:
                                                                                    "color: #" +
                                                                                    data
                                                                                      .item
                                                                                      .colors[0] +
                                                                                    "!important",
                                                                                  attrs: {
                                                                                    left:
                                                                                      ""
                                                                                  }
                                                                                },
                                                                                [
                                                                                  _vm._v(
                                                                                    "color_lens"
                                                                                  )
                                                                                ]
                                                                              )
                                                                            ],
                                                                            1
                                                                          ),
                                                                          _vm._v(
                                                                            " "
                                                                          ),
                                                                          _c(
                                                                            "v-list-tile-content",
                                                                            [
                                                                              _c(
                                                                                "div",
                                                                                {
                                                                                  domProps: {
                                                                                    textContent: _vm._s(
                                                                                      data
                                                                                        .item
                                                                                        .text
                                                                                    )
                                                                                  }
                                                                                }
                                                                              )
                                                                            ]
                                                                          )
                                                                        ]
                                                                      }
                                                                    }
                                                                  ]
                                                                ),
                                                                model: {
                                                                  value:
                                                                    _vm.color,
                                                                  callback: function(
                                                                    $$v
                                                                  ) {
                                                                    _vm.color = $$v
                                                                  },
                                                                  expression:
                                                                    "color"
                                                                }
                                                              })
                                                            ],
                                                            1
                                                          )
                                                        ],
                                                        1
                                                      ),
                                                      _vm._v(" "),
                                                      _c(
                                                        "v-layout",
                                                        {
                                                          attrs: {
                                                            row: "",
                                                            wrap: ""
                                                          }
                                                        },
                                                        _vm._l(4, function(i) {
                                                          return _c(
                                                            "v-flex",
                                                            {
                                                              key: i,
                                                              staticClass:
                                                                "xs12 sm6",
                                                              on: {
                                                                click: function(
                                                                  $event
                                                                ) {
                                                                  _vm.idxPicker =
                                                                    i - 1
                                                                }
                                                              }
                                                            },
                                                            [
                                                              _c(
                                                                "v-menu",
                                                                {
                                                                  attrs: {
                                                                    lazy: "",
                                                                    "close-on-content-click": false,
                                                                    transition:
                                                                      "scale-transition",
                                                                    "offset-y":
                                                                      "",
                                                                    "nudge-bottom": -20,
                                                                    "max-width":
                                                                      "225px"
                                                                  }
                                                                },
                                                                [
                                                                  _c(
                                                                    "v-text-field",
                                                                    {
                                                                      attrs: {
                                                                        slot:
                                                                          "activator",
                                                                        label: _vm._f(
                                                                          "cap"
                                                                        )(
                                                                          _vm
                                                                            .colorsLabel[
                                                                            i -
                                                                              1
                                                                          ]
                                                                        ),
                                                                        readonly:
                                                                          "",
                                                                        prefix:
                                                                          "#",
                                                                        box: "",
                                                                        hint: _vm._f(
                                                                          "cap"
                                                                        )(
                                                                          _vm
                                                                            .colorsHint[
                                                                            i -
                                                                              1
                                                                          ]
                                                                        ),
                                                                        "persistent-hint":
                                                                          ""
                                                                      },
                                                                      slot:
                                                                        "activator",
                                                                      model: {
                                                                        value:
                                                                          _vm
                                                                            .options
                                                                            .DSK_COLORS[
                                                                            i -
                                                                              1
                                                                          ],
                                                                        callback: function(
                                                                          $$v
                                                                        ) {
                                                                          _vm.$set(
                                                                            _vm
                                                                              .options
                                                                              .DSK_COLORS,
                                                                            i -
                                                                              1,
                                                                            $$v
                                                                          )
                                                                        },
                                                                        expression:
                                                                          "options.DSK_COLORS[i - 1]"
                                                                      }
                                                                    },
                                                                    [
                                                                      _c(
                                                                        "v-icon",
                                                                        {
                                                                          style:
                                                                            "color : #" +
                                                                            _vm
                                                                              .options
                                                                              .DSK_COLORS[
                                                                              i -
                                                                                1
                                                                            ] +
                                                                            ";",
                                                                          attrs: {
                                                                            slot:
                                                                              "append"
                                                                          },
                                                                          slot:
                                                                            "append"
                                                                        },
                                                                        [
                                                                          _vm._v(
                                                                            "style"
                                                                          )
                                                                        ]
                                                                      )
                                                                    ],
                                                                    1
                                                                  ),
                                                                  _vm._v(" "),
                                                                  _c(
                                                                    "chrome-picker",
                                                                    {
                                                                      attrs: {
                                                                        value:
                                                                          _vm
                                                                            .options
                                                                            .DSK_COLORS[
                                                                            i -
                                                                              1
                                                                          ]
                                                                      },
                                                                      on: {
                                                                        input:
                                                                          _vm.updateFromPicker
                                                                      }
                                                                    }
                                                                  )
                                                                ],
                                                                1
                                                              )
                                                            ],
                                                            1
                                                          )
                                                        }),
                                                        1
                                                      )
                                                    ],
                                                    1
                                                  )
                                                ],
                                                1
                                              )
                                            ],
                                            1
                                          )
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "v-expansion-panel-content",
                                        {
                                          attrs: {
                                            disabled: _vm.testBrideStatus(
                                              "parametre_apercu_dimensions"
                                            )
                                          }
                                        },
                                        [
                                          _c(
                                            "div",
                                            {
                                              attrs: { slot: "header" },
                                              slot: "header"
                                            },
                                            [
                                              _c(
                                                "v-icon",
                                                {
                                                  staticClass:
                                                    "mr-2 primary--text"
                                                },
                                                [_vm._v("transform")]
                                              ),
                                              _vm._v(
                                                "\n                  " +
                                                  _vm._s(
                                                    _vm._f("cap")(
                                                      _vm.$t("sizes")
                                                    )
                                                  ) +
                                                  "\n                  "
                                              ),
                                              _c("code", [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.options.DSK_WIDTH
                                                  ) +
                                                    "px x " +
                                                    _vm._s(
                                                      _vm.options.DSK_HEIGHT
                                                    ) +
                                                    "px"
                                                )
                                              ])
                                            ],
                                            1
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "v-card",
                                            [
                                              _c(
                                                "v-card-text",
                                                [
                                                  _c(
                                                    "v-slider",
                                                    {
                                                      attrs: {
                                                        min: 300,
                                                        max: 500,
                                                        "thumb-label": "always",
                                                        label: _vm._f("cap")(
                                                          _vm.$t("width")
                                                        )
                                                      },
                                                      model: {
                                                        value:
                                                          _vm.options.DSK_WIDTH,
                                                        callback: function(
                                                          $$v
                                                        ) {
                                                          _vm.$set(
                                                            _vm.options,
                                                            "DSK_WIDTH",
                                                            $$v
                                                          )
                                                        },
                                                        expression:
                                                          "options.DSK_WIDTH"
                                                      }
                                                    },
                                                    [
                                                      _c(
                                                        "v-icon",
                                                        {
                                                          attrs: {
                                                            slot: "prepend"
                                                          },
                                                          on: {
                                                            click: function(
                                                              $event
                                                            ) {
                                                              _vm.options
                                                                .DSK_WIDTH--
                                                            }
                                                          },
                                                          slot: "prepend"
                                                        },
                                                        [
                                                          _vm._v(
                                                            "\n                        remove_circle_outline\n                      "
                                                          )
                                                        ]
                                                      ),
                                                      _vm._v(" "),
                                                      _c(
                                                        "v-icon",
                                                        {
                                                          attrs: {
                                                            slot: "append"
                                                          },
                                                          on: {
                                                            click: function(
                                                              $event
                                                            ) {
                                                              _vm.options
                                                                .DSK_WIDTH++
                                                            }
                                                          },
                                                          slot: "append"
                                                        },
                                                        [
                                                          _vm._v(
                                                            "\n                        add_circle_outlines\n                      "
                                                          )
                                                        ]
                                                      )
                                                    ],
                                                    1
                                                  ),
                                                  _vm._v(" "),
                                                  _c(
                                                    "v-slider",
                                                    {
                                                      attrs: {
                                                        min: 350,
                                                        max: 800,
                                                        "thumb-label": "always",
                                                        label: _vm._f("cap")(
                                                          _vm.$t("height")
                                                        )
                                                      },
                                                      model: {
                                                        value:
                                                          _vm.options
                                                            .DSK_HEIGHT,
                                                        callback: function(
                                                          $$v
                                                        ) {
                                                          _vm.$set(
                                                            _vm.options,
                                                            "DSK_HEIGHT",
                                                            $$v
                                                          )
                                                        },
                                                        expression:
                                                          "options.DSK_HEIGHT"
                                                      }
                                                    },
                                                    [
                                                      _c(
                                                        "v-icon",
                                                        {
                                                          attrs: {
                                                            slot: "prepend"
                                                          },
                                                          on: {
                                                            click: function(
                                                              $event
                                                            ) {
                                                              _vm.options
                                                                .DSK_HEIGHT--
                                                            }
                                                          },
                                                          slot: "prepend"
                                                        },
                                                        [
                                                          _vm._v(
                                                            "\n                        remove_circle_outline\n                      "
                                                          )
                                                        ]
                                                      ),
                                                      _vm._v(" "),
                                                      _c(
                                                        "v-icon",
                                                        {
                                                          attrs: {
                                                            slot: "append"
                                                          },
                                                          on: {
                                                            click: function(
                                                              $event
                                                            ) {
                                                              _vm.options
                                                                .DSK_HEIGHT++
                                                            }
                                                          },
                                                          slot: "append"
                                                        },
                                                        [
                                                          _vm._v(
                                                            "\n                        add_circle_outlines\n                      "
                                                          )
                                                        ]
                                                      )
                                                    ],
                                                    1
                                                  )
                                                ],
                                                1
                                              )
                                            ],
                                            1
                                          )
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "v-expansion-panel-content",
                                        {
                                          attrs: {
                                            disabled: _vm.testBrideStatus(
                                              "parametre_apercu_coins"
                                            )
                                          }
                                        },
                                        [
                                          _c(
                                            "div",
                                            {
                                              attrs: { slot: "header" },
                                              slot: "header"
                                            },
                                            [
                                              _c(
                                                "v-icon",
                                                {
                                                  staticClass:
                                                    "mr-2 primary--text"
                                                },
                                                [_vm._v("rounded_corner")]
                                              ),
                                              _vm._v(
                                                "\n                  " +
                                                  _vm._s(
                                                    _vm.$t("previewArronfi")
                                                  ) +
                                                  "\n                  "
                                              ),
                                              _c("code", [
                                                _vm._v(
                                                  _vm._s(_vm.radius) + "px"
                                                )
                                              ])
                                            ],
                                            1
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "v-card",
                                            [
                                              _c(
                                                "v-card-text",
                                                [
                                                  _c(
                                                    "v-slider",
                                                    {
                                                      attrs: {
                                                        min: 0,
                                                        max: 12,
                                                        "thumb-label": "always",
                                                        label: _vm.$t(
                                                          "settArondi"
                                                        )
                                                      },
                                                      model: {
                                                        value: _vm.radius,
                                                        callback: function(
                                                          $$v
                                                        ) {
                                                          _vm.radius = $$v
                                                        },
                                                        expression: "radius"
                                                      }
                                                    },
                                                    [
                                                      _c(
                                                        "v-icon",
                                                        {
                                                          attrs: {
                                                            slot: "prepend"
                                                          },
                                                          on: {
                                                            click: function(
                                                              $event
                                                            ) {
                                                              _vm.radius--
                                                            }
                                                          },
                                                          slot: "prepend"
                                                        },
                                                        [
                                                          _vm._v(
                                                            "\n                        remove_circle_outline\n                      "
                                                          )
                                                        ]
                                                      ),
                                                      _vm._v(" "),
                                                      _c(
                                                        "v-icon",
                                                        {
                                                          attrs: {
                                                            slot: "append"
                                                          },
                                                          on: {
                                                            click: function(
                                                              $event
                                                            ) {
                                                              _vm.radius++
                                                            }
                                                          },
                                                          slot: "append"
                                                        },
                                                        [
                                                          _vm._v(
                                                            "\n                        add_circle_outlines\n                      "
                                                          )
                                                        ]
                                                      )
                                                    ],
                                                    1
                                                  )
                                                ],
                                                1
                                              )
                                            ],
                                            1
                                          )
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "v-expansion-panel-content",
                            { attrs: { expand: "" } },
                            [
                              _c(
                                "div",
                                { attrs: { slot: "header" }, slot: "header" },
                                [
                                  _c(
                                    "v-icon",
                                    { staticClass: "mr-2 primary--text" },
                                    [_vm._v("view_compact")]
                                  ),
                                  _vm._v(
                                    "\n              " +
                                      _vm._s(_vm.$t("previewPositio")) +
                                      "\n            "
                                  )
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "v-card",
                                { staticClass: "ml-3" },
                                [
                                  _c(
                                    "v-expansion-panel",
                                    [
                                      _c(
                                        "v-expansion-panel-content",
                                        {
                                          attrs: {
                                            disabled: _vm.testBrideStatus(
                                              "parametre_apercu_position"
                                            )
                                          }
                                        },
                                        [
                                          _c(
                                            "div",
                                            {
                                              attrs: { slot: "header" },
                                              slot: "header"
                                            },
                                            [
                                              _c(
                                                "v-icon",
                                                {
                                                  staticClass:
                                                    "mr-2 primary--text"
                                                },
                                                [_vm._v("view_compact")]
                                              ),
                                              _vm._v(
                                                "\n                  " +
                                                  _vm._s(
                                                    _vm._f("cap")(
                                                      _vm.$t("position")
                                                    )
                                                  ) +
                                                  " Desktop\n                  "
                                              ),
                                              _c("code", [
                                                _vm._v(_vm._s(_vm.position))
                                              ])
                                            ],
                                            1
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "v-card",
                                            [
                                              _c(
                                                "v-subheader",
                                                { staticClass: "ml-3" },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.$t("previewPlacer")
                                                    ) +
                                                      " " +
                                                      _vm._s(_vm.position)
                                                  )
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "v-card-text",
                                                {
                                                  staticClass: "mt-5",
                                                  staticStyle: {
                                                    "max-width": "300px"
                                                  }
                                                },
                                                [
                                                  _c(
                                                    "v-layout",
                                                    {
                                                      attrs: {
                                                        row: "",
                                                        "justify-space-between":
                                                          "",
                                                        "mb-4": ""
                                                      }
                                                    },
                                                    [
                                                      _c(
                                                        "v-flex",
                                                        { attrs: { xs1: "" } },
                                                        [
                                                          _c("v-btn", {
                                                            staticClass:
                                                              "rotate ml-0",
                                                            class: {
                                                              primary:
                                                                _vm.options
                                                                  .DSK_TAB_SIDE ==
                                                                "LEFT"
                                                            },
                                                            attrs: {
                                                              small: "",
                                                              light: ""
                                                            },
                                                            on: {
                                                              click: function(
                                                                $event
                                                              ) {
                                                                _vm.options.DSK_TAB_SIDE =
                                                                  "LEFT"
                                                              }
                                                            }
                                                          })
                                                        ],
                                                        1
                                                      ),
                                                      _vm._v(" "),
                                                      _c("v-flex", {
                                                        attrs: { xs2: "" }
                                                      }),
                                                      _vm._v(" "),
                                                      _c(
                                                        "v-flex",
                                                        {
                                                          attrs: {
                                                            xs1: "",
                                                            "ml-0": ""
                                                          }
                                                        },
                                                        [
                                                          _c("v-btn", {
                                                            staticClass:
                                                              "rotate mb-0",
                                                            class: {
                                                              primary:
                                                                _vm.options
                                                                  .DSK_TAB_SIDE ==
                                                                "RIGHT"
                                                            },
                                                            attrs: {
                                                              small: "",
                                                              light: ""
                                                            },
                                                            on: {
                                                              click: function(
                                                                $event
                                                              ) {
                                                                _vm.options.DSK_TAB_SIDE =
                                                                  "RIGHT"
                                                              }
                                                            }
                                                          })
                                                        ],
                                                        1
                                                      )
                                                    ],
                                                    1
                                                  ),
                                                  _vm._v(" "),
                                                  _c(
                                                    "v-layout",
                                                    {
                                                      attrs: {
                                                        row: "",
                                                        "justify-space-between":
                                                          ""
                                                      }
                                                    },
                                                    [
                                                      _c(
                                                        "v-flex",
                                                        { attrs: { xs2: "" } },
                                                        [
                                                          _c("v-btn", {
                                                            staticClass: "ml-4",
                                                            class: {
                                                              primary:
                                                                _vm.options
                                                                  .DSK_TAB_SIDE ==
                                                                  "BOTTOM" &&
                                                                _vm.options
                                                                  .DSK_TAB_POS ==
                                                                  "0"
                                                            },
                                                            attrs: {
                                                              small: "",
                                                              light: ""
                                                            },
                                                            on: {
                                                              click: function(
                                                                $event
                                                              ) {
                                                                _vm.options.DSK_TAB_SIDE =
                                                                  "BOTTOM"
                                                                _vm.options.DSK_TAB_POS =
                                                                  "0"
                                                              }
                                                            }
                                                          })
                                                        ],
                                                        1
                                                      ),
                                                      _vm._v(" "),
                                                      _c(
                                                        "v-flex",
                                                        { attrs: { xs2: "" } },
                                                        [
                                                          _c("v-btn", {
                                                            staticClass: "ml-3",
                                                            class: {
                                                              primary:
                                                                _vm.options
                                                                  .DSK_TAB_SIDE ==
                                                                  "BOTTOM" &&
                                                                _vm.options
                                                                  .DSK_TAB_POS ==
                                                                  "50"
                                                            },
                                                            attrs: {
                                                              small: "",
                                                              light: ""
                                                            },
                                                            on: {
                                                              click: function(
                                                                $event
                                                              ) {
                                                                _vm.options.DSK_TAB_SIDE =
                                                                  "BOTTOM"
                                                                _vm.options.DSK_TAB_POS =
                                                                  "50"
                                                              }
                                                            }
                                                          })
                                                        ],
                                                        1
                                                      ),
                                                      _vm._v(" "),
                                                      _c(
                                                        "v-flex",
                                                        { attrs: { xs2: "" } },
                                                        [
                                                          _c("v-btn", {
                                                            class: {
                                                              primary:
                                                                _vm.options
                                                                  .DSK_TAB_SIDE ==
                                                                  "BOTTOM" &&
                                                                _vm.options
                                                                  .DSK_TAB_POS ==
                                                                  "100"
                                                            },
                                                            attrs: {
                                                              small: "",
                                                              light: ""
                                                            },
                                                            on: {
                                                              click: function(
                                                                $event
                                                              ) {
                                                                _vm.options.DSK_TAB_SIDE =
                                                                  "BOTTOM"
                                                                _vm.options.DSK_TAB_POS =
                                                                  "100"
                                                              }
                                                            }
                                                          })
                                                        ],
                                                        1
                                                      )
                                                    ],
                                                    1
                                                  )
                                                ],
                                                1
                                              )
                                            ],
                                            1
                                          )
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "v-expansion-panel-content",
                                        {
                                          attrs: {
                                            disabled: _vm.testBrideStatus(
                                              "parametre_apercu_mobile_position"
                                            )
                                          }
                                        },
                                        [
                                          _c(
                                            "div",
                                            {
                                              attrs: { slot: "header" },
                                              slot: "header"
                                            },
                                            [
                                              _c(
                                                "v-icon",
                                                {
                                                  staticClass:
                                                    "mr-2 primary--text"
                                                },
                                                [_vm._v("view_compact")]
                                              ),
                                              _vm._v(
                                                "\n                  " +
                                                  _vm._s(
                                                    _vm.$t(
                                                      "previewPositioMobil"
                                                    )
                                                  ) +
                                                  "\n                  "
                                              ),
                                              _c("code", [
                                                _vm._v(
                                                  _vm._s(_vm.positionMobile)
                                                )
                                              ])
                                            ],
                                            1
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "v-card",
                                            [
                                              _c(
                                                "v-subheader",
                                                { staticClass: "ml-3" },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.$t("previewPlacer")
                                                    ) +
                                                      " " +
                                                      _vm._s(_vm.positionMobile)
                                                  )
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "v-card-text",
                                                {
                                                  staticClass: "mt-5",
                                                  staticStyle: {
                                                    "max-width": "300px"
                                                  }
                                                },
                                                [
                                                  _c(
                                                    "v-layout",
                                                    {
                                                      attrs: {
                                                        row: "",
                                                        "justify-space-between":
                                                          ""
                                                      }
                                                    },
                                                    [
                                                      _c(
                                                        "v-flex",
                                                        { attrs: { xs2: "" } },
                                                        [
                                                          _c("v-btn", {
                                                            staticClass: "ml-4",
                                                            class: {
                                                              primary:
                                                                _vm.options
                                                                  .DSK_TAB_SIDE_MOBILE ==
                                                                  "BOTTOM" &&
                                                                _vm.options
                                                                  .DSK_TAB_POS_MOBILE ==
                                                                  "0"
                                                            },
                                                            attrs: {
                                                              small: "",
                                                              light: ""
                                                            },
                                                            on: {
                                                              click: function(
                                                                $event
                                                              ) {
                                                                _vm.options.DSK_TAB_SIDE_MOBILE =
                                                                  "BOTTOM"
                                                                _vm.options.DSK_TAB_POS_MOBILE =
                                                                  "0"
                                                              }
                                                            }
                                                          })
                                                        ],
                                                        1
                                                      ),
                                                      _vm._v(" "),
                                                      _c(
                                                        "v-flex",
                                                        { attrs: { xs2: "" } },
                                                        [
                                                          _c("v-btn", {
                                                            staticClass: "ml-3",
                                                            class: {
                                                              primary:
                                                                _vm.options
                                                                  .DSK_TAB_SIDE_MOBILE ==
                                                                  "BOTTOM" &&
                                                                _vm.options
                                                                  .DSK_TAB_POS_MOBILE ==
                                                                  "50"
                                                            },
                                                            attrs: {
                                                              small: "",
                                                              light: ""
                                                            },
                                                            on: {
                                                              click: function(
                                                                $event
                                                              ) {
                                                                _vm.options.DSK_TAB_SIDE_MOBILE =
                                                                  "BOTTOM"
                                                                _vm.options.DSK_TAB_POS_MOBILE =
                                                                  "50"
                                                              }
                                                            }
                                                          })
                                                        ],
                                                        1
                                                      ),
                                                      _vm._v(" "),
                                                      _c(
                                                        "v-flex",
                                                        { attrs: { xs2: "" } },
                                                        [
                                                          _c("v-btn", {
                                                            class: {
                                                              primary:
                                                                _vm.options
                                                                  .DSK_TAB_SIDE_MOBILE ==
                                                                  "BOTTOM" &&
                                                                _vm.options
                                                                  .DSK_TAB_POS_MOBILE ==
                                                                  "100"
                                                            },
                                                            attrs: {
                                                              small: "",
                                                              light: ""
                                                            },
                                                            on: {
                                                              click: function(
                                                                $event
                                                              ) {
                                                                _vm.options.DSK_TAB_SIDE_MOBILE =
                                                                  "BOTTOM"
                                                                _vm.options.DSK_TAB_POS_MOBILE =
                                                                  "100"
                                                              }
                                                            }
                                                          })
                                                        ],
                                                        1
                                                      )
                                                    ],
                                                    1
                                                  )
                                                ],
                                                1
                                              )
                                            ],
                                            1
                                          )
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "v-expansion-panel-content",
                            [
                              _c(
                                "div",
                                { attrs: { slot: "header" }, slot: "header" },
                                [
                                  _c(
                                    "v-icon",
                                    { staticClass: "mr-2 primary--text" },
                                    [_vm._v("wb_iridescent")]
                                  ),
                                  _vm._v(
                                    "\n              " +
                                      _vm._s(_vm.$t("previewRetract")) +
                                      "\n            "
                                  )
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "v-card",
                                { staticClass: "ml-3" },
                                [
                                  _c(
                                    "v-expansion-panel",
                                    [
                                      _c(
                                        "v-expansion-panel-content",
                                        {
                                          attrs: {
                                            disabled: _vm.testBrideStatus(
                                              "parametre_apercu_desk"
                                            )
                                          }
                                        },
                                        [
                                          _c(
                                            "div",
                                            {
                                              attrs: { slot: "header" },
                                              slot: "header"
                                            },
                                            [
                                              _c(
                                                "v-icon",
                                                {
                                                  staticClass:
                                                    "mr-2 primary--text"
                                                },
                                                [_vm._v("wb_iridescent")]
                                              ),
                                              _vm._v(
                                                "\n                  " +
                                                  _vm._s(
                                                    _vm._f("cap")(
                                                      _vm.$t(
                                                        "defaultAppearance"
                                                      )
                                                    )
                                                  ) +
                                                  " desktop\n                  "
                                              ),
                                              _c("code", [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.options
                                                      .DSK_WIDGETSTATE === "3"
                                                      ? _vm.$t("mini")
                                                      : _vm.$t("middle")
                                                  )
                                                )
                                              ])
                                            ],
                                            1
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "v-card",
                                            [
                                              _c(
                                                "v-card-text",
                                                [
                                                  _c(
                                                    "v-radio-group",
                                                    {
                                                      attrs: {
                                                        row: "",
                                                        hint: _vm.$t(
                                                          "labelWidgetState"
                                                        ),
                                                        "persistent-hint": ""
                                                      },
                                                      model: {
                                                        value:
                                                          _vm.options
                                                            .DSK_WIDGETSTATE,
                                                        callback: function(
                                                          $$v
                                                        ) {
                                                          _vm.$set(
                                                            _vm.options,
                                                            "DSK_WIDGETSTATE",
                                                            $$v
                                                          )
                                                        },
                                                        expression:
                                                          "options.DSK_WIDGETSTATE"
                                                      }
                                                    },
                                                    [
                                                      _c("v-radio", {
                                                        attrs: {
                                                          color: "primary",
                                                          label: _vm._f("cap")(
                                                            _vm.$t("mini")
                                                          ),
                                                          value: "3"
                                                        }
                                                      }),
                                                      _vm._v(" "),
                                                      _c("v-radio", {
                                                        attrs: {
                                                          color: "primary",
                                                          label: _vm._f("cap")(
                                                            _vm.$t("middle")
                                                          ),
                                                          value: "2"
                                                        }
                                                      })
                                                    ],
                                                    1
                                                  )
                                                ],
                                                1
                                              )
                                            ],
                                            1
                                          )
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "v-expansion-panel-content",
                                        {
                                          attrs: {
                                            disabled: _vm.testBrideStatus(
                                              "parametre_apercu_mobile_desk"
                                            )
                                          }
                                        },
                                        [
                                          _c(
                                            "div",
                                            {
                                              attrs: { slot: "header" },
                                              slot: "header"
                                            },
                                            [
                                              _c(
                                                "v-icon",
                                                {
                                                  staticClass:
                                                    "mr-2 primary--text"
                                                },
                                                [_vm._v("wb_iridescent")]
                                              ),
                                              _vm._v(
                                                "\n                  " +
                                                  _vm._s(
                                                    _vm._f("cap")(
                                                      _vm.$t(
                                                        "defaultAppearance"
                                                      )
                                                    )
                                                  ) +
                                                  " mobile\n                  "
                                              ),
                                              _c("code", [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.options
                                                      .DSK_WIDGETSTATE_MOBILE ===
                                                      "3"
                                                      ? _vm.$t("mini")
                                                      : _vm.$t("middle")
                                                  )
                                                )
                                              ])
                                            ],
                                            1
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "v-card",
                                            [
                                              _c(
                                                "v-card-text",
                                                [
                                                  _c(
                                                    "v-radio-group",
                                                    {
                                                      attrs: {
                                                        row: "",
                                                        hint: _vm.$t(
                                                          "labelWidgetState"
                                                        ),
                                                        "persistent-hint": ""
                                                      },
                                                      model: {
                                                        value:
                                                          _vm.options
                                                            .DSK_WIDGETSTATE_MOBILE,
                                                        callback: function(
                                                          $$v
                                                        ) {
                                                          _vm.$set(
                                                            _vm.options,
                                                            "DSK_WIDGETSTATE_MOBILE",
                                                            $$v
                                                          )
                                                        },
                                                        expression:
                                                          "options.DSK_WIDGETSTATE_MOBILE"
                                                      }
                                                    },
                                                    [
                                                      _c("v-radio", {
                                                        attrs: {
                                                          color: "primary",
                                                          label: _vm._f("cap")(
                                                            _vm.$t("mini")
                                                          ),
                                                          value: "3"
                                                        }
                                                      }),
                                                      _vm._v(" "),
                                                      _c("v-radio", {
                                                        attrs: {
                                                          color: "primary",
                                                          label: _vm._f("cap")(
                                                            _vm.$t("middle")
                                                          ),
                                                          value: "2"
                                                        }
                                                      })
                                                    ],
                                                    1
                                                  )
                                                ],
                                                1
                                              )
                                            ],
                                            1
                                          )
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "v-expansion-panel-content",
                                        {
                                          attrs: {
                                            disabled: _vm.testBrideStatus(
                                              "parametre_apercu_hide_moyen"
                                            )
                                          }
                                        },
                                        [
                                          _c(
                                            "div",
                                            {
                                              attrs: { slot: "header" },
                                              slot: "header"
                                            },
                                            [
                                              _c(
                                                "v-icon",
                                                {
                                                  staticClass:
                                                    "mr-2 primary--text"
                                                },
                                                [_vm._v("visibility_off")]
                                              ),
                                              _vm._v(
                                                "\n                    " +
                                                  _vm._s(
                                                    _vm.$t("previewCacher")
                                                  ) +
                                                  " \n                  "
                                              ),
                                              _c("code", [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.options
                                                      .DSK_HIDE_MIDDLE_STATE
                                                      ? _vm.$t("yes")
                                                      : _vm.$t("no")
                                                  )
                                                )
                                              ])
                                            ],
                                            1
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "v-card",
                                            [
                                              _c(
                                                "v-card-text",
                                                [
                                                  _c("v-switch", {
                                                    attrs: {
                                                      label:
                                                        "Cacher l'état moyen",
                                                      color: "primary",
                                                      hint:
                                                        "Compatible avec 'Apparence par défaut': 'Moyen'. En effet le widget pourra être en 'Moyen' par défaut, au début de la session du visiteur.",
                                                      "persistent-hint": ""
                                                    },
                                                    model: {
                                                      value:
                                                        _vm.options
                                                          .DSK_HIDE_MIDDLE_STATE,
                                                      callback: function($$v) {
                                                        _vm.$set(
                                                          _vm.options,
                                                          "DSK_HIDE_MIDDLE_STATE",
                                                          $$v
                                                        )
                                                      },
                                                      expression:
                                                        "options.DSK_HIDE_MIDDLE_STATE"
                                                    }
                                                  })
                                                ],
                                                1
                                              )
                                            ],
                                            1
                                          )
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "v-expansion-panel-content",
                                        {
                                          attrs: {
                                            disabled: _vm.testBrideStatus(
                                              "parametre_apercu_conseiller"
                                            )
                                          },
                                          nativeOn: {
                                            click: function($event) {
                                              return _vm.loadImg(true)
                                            }
                                          }
                                        },
                                        [
                                          _c(
                                            "div",
                                            {
                                              attrs: { slot: "header" },
                                              slot: "header"
                                            },
                                            [
                                              _c(
                                                "v-icon",
                                                {
                                                  staticClass:
                                                    "mr-2 primary--text"
                                                },
                                                [_vm._v("photo")]
                                              ),
                                              _vm._v(
                                                "\n                  " +
                                                  _vm._s(
                                                    _vm.$t("previewAvatarChat")
                                                  ) +
                                                  " \n                "
                                              )
                                            ],
                                            1
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "v-card",
                                            [
                                              _c(
                                                "v-card-text",
                                                [
                                                  _c(
                                                    "v-container",
                                                    {
                                                      attrs: {
                                                        "grid-list-sm": "",
                                                        fluid: ""
                                                      }
                                                    },
                                                    [
                                                      _vm.imagesAgent.length
                                                        ? _c(
                                                            "v-layout",
                                                            {
                                                              attrs: {
                                                                row: "",
                                                                wrap: ""
                                                              }
                                                            },
                                                            _vm._l(
                                                              _vm.imagesAgent,
                                                              function(img, i) {
                                                                return _c(
                                                                  "v-flex",
                                                                  {
                                                                    key: i,
                                                                    attrs: {
                                                                      xs2: "",
                                                                      "d-flex":
                                                                        ""
                                                                    }
                                                                  },
                                                                  [
                                                                    _c(
                                                                      "v-hover",
                                                                      {
                                                                        scopedSlots: _vm._u(
                                                                          [
                                                                            {
                                                                              key:
                                                                                "default",
                                                                              fn: function(
                                                                                ref
                                                                              ) {
                                                                                var hover =
                                                                                  ref.hover
                                                                                return _c(
                                                                                  "v-card",
                                                                                  {
                                                                                    staticClass:
                                                                                      "d-flex picto",
                                                                                    class:
                                                                                      "elevation-" +
                                                                                      (hover
                                                                                        ? 6
                                                                                        : 0),
                                                                                    staticStyle: {
                                                                                      cursor:
                                                                                        "pointer"
                                                                                    },
                                                                                    attrs: {
                                                                                      flat:
                                                                                        "",
                                                                                      tile:
                                                                                        "",
                                                                                      id:
                                                                                        "picto_" +
                                                                                        i
                                                                                    },
                                                                                    on: {
                                                                                      click: function(
                                                                                        $event
                                                                                      ) {
                                                                                        return _vm.updateImg(
                                                                                          true,
                                                                                          img,
                                                                                          i
                                                                                        )
                                                                                      }
                                                                                    }
                                                                                  },
                                                                                  [
                                                                                    _c(
                                                                                      "v-img",
                                                                                      {
                                                                                        attrs: {
                                                                                          src: img
                                                                                        }
                                                                                      },
                                                                                      [
                                                                                        _c(
                                                                                          "v-layout",
                                                                                          {
                                                                                            attrs: {
                                                                                              slot:
                                                                                                "placeholder",
                                                                                              "fill-height":
                                                                                                "",
                                                                                              "align-center":
                                                                                                "",
                                                                                              "justify-center":
                                                                                                "",
                                                                                              "ma-0":
                                                                                                ""
                                                                                            },
                                                                                            slot:
                                                                                              "placeholder"
                                                                                          },
                                                                                          [
                                                                                            _c(
                                                                                              "v-progress-circular",
                                                                                              {
                                                                                                attrs: {
                                                                                                  indeterminate:
                                                                                                    "",
                                                                                                  color:
                                                                                                    "grey lighten-5"
                                                                                                }
                                                                                              }
                                                                                            )
                                                                                          ],
                                                                                          1
                                                                                        )
                                                                                      ],
                                                                                      1
                                                                                    )
                                                                                  ],
                                                                                  1
                                                                                )
                                                                              }
                                                                            }
                                                                          ],
                                                                          null,
                                                                          true
                                                                        )
                                                                      }
                                                                    )
                                                                  ],
                                                                  1
                                                                )
                                                              }
                                                            ),
                                                            1
                                                          )
                                                        : _c(
                                                            "v-progress-circular",
                                                            {
                                                              attrs: {
                                                                indeterminate:
                                                                  "",
                                                                color: "primary"
                                                              }
                                                            }
                                                          )
                                                    ],
                                                    1
                                                  )
                                                ],
                                                1
                                              )
                                            ],
                                            1
                                          )
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "v-expansion-panel-content",
                                        {
                                          attrs: {
                                            disabled: _vm.testBrideStatus(
                                              "parametre_apercu_bot"
                                            )
                                          },
                                          nativeOn: {
                                            click: function($event) {
                                              return _vm.loadImg(false)
                                            }
                                          }
                                        },
                                        [
                                          _c(
                                            "div",
                                            {
                                              attrs: { slot: "header" },
                                              slot: "header"
                                            },
                                            [
                                              _c(
                                                "v-icon",
                                                {
                                                  staticClass:
                                                    "mr-2 primary--text"
                                                },
                                                [_vm._v("photo")]
                                              ),
                                              _vm._v(
                                                "\n                  " +
                                                  _vm._s(
                                                    _vm.$t("previewAvatarBot")
                                                  ) +
                                                  " \n                "
                                              )
                                            ],
                                            1
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "v-card",
                                            [
                                              _c(
                                                "v-card-text",
                                                [
                                                  _c(
                                                    "v-container",
                                                    {
                                                      attrs: {
                                                        "grid-list-sm": "",
                                                        fluid: ""
                                                      }
                                                    },
                                                    [
                                                      _vm.imagesBot.length
                                                        ? _c(
                                                            "v-layout",
                                                            {
                                                              attrs: {
                                                                row: "",
                                                                wrap: ""
                                                              }
                                                            },
                                                            _vm._l(
                                                              _vm.imagesBot,
                                                              function(img, i) {
                                                                return _c(
                                                                  "v-flex",
                                                                  {
                                                                    key: i,
                                                                    attrs: {
                                                                      xs2: "",
                                                                      "d-flex":
                                                                        ""
                                                                    }
                                                                  },
                                                                  [
                                                                    _c(
                                                                      "v-hover",
                                                                      {
                                                                        scopedSlots: _vm._u(
                                                                          [
                                                                            {
                                                                              key:
                                                                                "default",
                                                                              fn: function(
                                                                                ref
                                                                              ) {
                                                                                var hover =
                                                                                  ref.hover
                                                                                return _c(
                                                                                  "v-card",
                                                                                  {
                                                                                    staticClass:
                                                                                      "d-flex picto",
                                                                                    class:
                                                                                      "elevation-" +
                                                                                      (hover
                                                                                        ? 6
                                                                                        : 0),
                                                                                    staticStyle: {
                                                                                      cursor:
                                                                                        "pointer"
                                                                                    },
                                                                                    attrs: {
                                                                                      flat:
                                                                                        "",
                                                                                      tile:
                                                                                        "",
                                                                                      id:
                                                                                        "picto_" +
                                                                                        i
                                                                                    },
                                                                                    on: {
                                                                                      click: function(
                                                                                        $event
                                                                                      ) {
                                                                                        return _vm.updateImg(
                                                                                          false,
                                                                                          img,
                                                                                          i
                                                                                        )
                                                                                      }
                                                                                    }
                                                                                  },
                                                                                  [
                                                                                    _c(
                                                                                      "v-img",
                                                                                      {
                                                                                        attrs: {
                                                                                          src: img
                                                                                        }
                                                                                      },
                                                                                      [
                                                                                        _c(
                                                                                          "v-layout",
                                                                                          {
                                                                                            attrs: {
                                                                                              slot:
                                                                                                "placeholder",
                                                                                              "fill-height":
                                                                                                "",
                                                                                              "align-center":
                                                                                                "",
                                                                                              "justify-center":
                                                                                                "",
                                                                                              "ma-0":
                                                                                                ""
                                                                                            },
                                                                                            slot:
                                                                                              "placeholder"
                                                                                          },
                                                                                          [
                                                                                            _c(
                                                                                              "v-progress-circular",
                                                                                              {
                                                                                                attrs: {
                                                                                                  indeterminate:
                                                                                                    "",
                                                                                                  color:
                                                                                                    "grey lighten-5"
                                                                                                }
                                                                                              }
                                                                                            )
                                                                                          ],
                                                                                          1
                                                                                        )
                                                                                      ],
                                                                                      1
                                                                                    )
                                                                                  ],
                                                                                  1
                                                                                )
                                                                              }
                                                                            }
                                                                          ],
                                                                          null,
                                                                          true
                                                                        )
                                                                      }
                                                                    )
                                                                  ],
                                                                  1
                                                                )
                                                              }
                                                            ),
                                                            1
                                                          )
                                                        : _c(
                                                            "v-progress-circular",
                                                            {
                                                              attrs: {
                                                                indeterminate:
                                                                  "",
                                                                color: "primary"
                                                              }
                                                            }
                                                          )
                                                    ],
                                                    1
                                                  )
                                                ],
                                                1
                                              )
                                            ],
                                            1
                                          )
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "v-expansion-panel-content",
                            {
                              attrs: {
                                disabled: _vm.testBrideStatus(
                                  "parametre_apercu_sideon"
                                )
                              }
                            },
                            [
                              _c(
                                "div",
                                { attrs: { slot: "header" }, slot: "header" },
                                [
                                  _c(
                                    "v-icon",
                                    { staticClass: "mr-2 primary--text" },
                                    [_vm._v("chrome_reader_mode")]
                                  ),
                                  _vm._v(
                                    "\n              " +
                                      _vm._s(_vm.$t("previewDeploy")) +
                                      "\n              "
                                  ),
                                  _c(
                                    "v-tooltip",
                                    {
                                      attrs: { bottom: "" },
                                      nativeOn: {
                                        click: function($event) {
                                          $event.stopPropagation()
                                          _vm.openDialog({
                                            title: _vm.$t("titleInfoSideOn"),
                                            content: _vm.$t("contentInfoSideOn")
                                          })
                                        }
                                      }
                                    },
                                    [
                                      _c(
                                        "template",
                                        { slot: "activator" },
                                        [
                                          _c(
                                            "v-icon",
                                            {
                                              staticClass: "infos",
                                              attrs: {
                                                color: "grey lighten-1",
                                                dark: ""
                                              }
                                            },
                                            [_vm._v("info")]
                                          )
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c("span", [
                                        _vm._v(_vm._s(_vm.$t("enSavoirPlus")))
                                      ])
                                    ],
                                    2
                                  )
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "v-card",
                                { staticClass: "ml-3" },
                                [
                                  _vm.checkPermission(
                                    "NO_PEONS_NO_AGENTS_NO_ADMINS_NO_SUPER"
                                  )
                                    ? _c(
                                        "v-card-text",
                                        [
                                          _c("v-switch", {
                                            attrs: {
                                              label:
                                                "Side On (Desktop uniquement)",
                                              color: "primary",
                                              hint: _vm.$t("sideoneDesciption"),
                                              "persistent-hint": ""
                                            },
                                            model: {
                                              value: _vm.options.DSK_SIDEON,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.options,
                                                  "DSK_SIDEON",
                                                  $$v
                                                )
                                              },
                                              expression: "options.DSK_SIDEON"
                                            }
                                          }),
                                          _vm._v(" "),
                                          _c("v-switch", {
                                            attrs: {
                                              label:
                                                "Side hover (Desktop uniquement)",
                                              color: "primary",
                                              hint: _vm.$t(
                                                "sideoneDescription2"
                                              ),
                                              "persistent-hint": ""
                                            },
                                            model: {
                                              value: _vm.options.DSK_SIDEHOVER,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.options,
                                                  "DSK_SIDEHOVER",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "options.DSK_SIDEHOVER"
                                            }
                                          })
                                        ],
                                        1
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _c(
                                    "v-expansion-panel",
                                    [
                                      _c(
                                        "v-expansion-panel-content",
                                        {
                                          attrs: {
                                            disabled: _vm.testBrideStatus(
                                              "parametre_apercu_hide_liste"
                                            )
                                          }
                                        },
                                        [
                                          _c(
                                            "div",
                                            {
                                              attrs: { slot: "header" },
                                              slot: "header"
                                            },
                                            [
                                              _c(
                                                "v-icon",
                                                {
                                                  staticClass:
                                                    "mr-2 primary--text"
                                                },
                                                [_vm._v("people")]
                                              ),
                                              _vm._v(
                                                "\n                    " +
                                                  _vm._s(
                                                    _vm._f("cap")(
                                                      _vm.$t("showAgentList")
                                                    )
                                                  ) +
                                                  "\n                    "
                                              ),
                                              _c("code", [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.options
                                                      .DSK_HIDE_AGENT_LIST
                                                      ? _vm.$t("yes")
                                                      : _vm.$t("no")
                                                  )
                                                )
                                              ])
                                            ],
                                            1
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "v-card",
                                            [
                                              _c(
                                                "v-card-text",
                                                [
                                                  _c("v-switch", {
                                                    attrs: {
                                                      label: _vm.$t(
                                                        "showAgentList"
                                                      ),
                                                      color: "primary"
                                                    },
                                                    model: {
                                                      value:
                                                        _vm.options
                                                          .DSK_HIDE_AGENT_LIST,
                                                      callback: function($$v) {
                                                        _vm.$set(
                                                          _vm.options,
                                                          "DSK_HIDE_AGENT_LIST",
                                                          $$v
                                                        )
                                                      },
                                                      expression:
                                                        "options.DSK_HIDE_AGENT_LIST"
                                                    }
                                                  })
                                                ],
                                                1
                                              )
                                            ],
                                            1
                                          )
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "v-expansion-panel-content",
                            [
                              _c(
                                "div",
                                { attrs: { slot: "header" }, slot: "header" },
                                [
                                  _c(
                                    "v-icon",
                                    { staticClass: "mr-2 primary--text" },
                                    [_vm._v("text_fields")]
                                  ),
                                  _vm._v(
                                    "\n              " +
                                      _vm._s(_vm.$t("settContenu")) +
                                      "\n            "
                                  )
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "v-card",
                                { staticClass: "ml-3" },
                                [
                                  _c(
                                    "v-expansion-panel",
                                    [
                                      _c(
                                        "v-expansion-panel-content",
                                        {
                                          attrs: {
                                            disabled: _vm.testBrideStatus(
                                              "parametre_apercu_lang"
                                            )
                                          }
                                        },
                                        [
                                          _c(
                                            "div",
                                            {
                                              attrs: { slot: "header" },
                                              slot: "header"
                                            },
                                            [
                                              _c(
                                                "v-icon",
                                                {
                                                  staticClass:
                                                    "mr-2 primary--text"
                                                },
                                                [_vm._v("translate")]
                                              ),
                                              _vm._v(
                                                "\n                  " +
                                                  _vm._s(
                                                    _vm.$t("previewLang")
                                                  ) +
                                                  "\n                  "
                                              ),
                                              _c("code", [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.options.DSK_GETELANG ===
                                                      ""
                                                      ? _vm.$t("defaut")
                                                      : _vm.options.DSK_GETELANG
                                                  )
                                                )
                                              ])
                                            ],
                                            1
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "v-card",
                                            [
                                              _c(
                                                "v-card-text",
                                                [
                                                  _c("v-select", {
                                                    attrs: {
                                                      dense: "",
                                                      items: _vm.langsFront,
                                                      label: _vm.$t("language"),
                                                      "prepend-icon":
                                                        "translate"
                                                    },
                                                    model: {
                                                      value:
                                                        _vm.options
                                                          .DSK_GETELANG,
                                                      callback: function($$v) {
                                                        _vm.$set(
                                                          _vm.options,
                                                          "DSK_GETELANG",
                                                          $$v
                                                        )
                                                      },
                                                      expression:
                                                        "options.DSK_GETELANG"
                                                    }
                                                  }),
                                                  _vm._v(" "),
                                                  _c("small", [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm._f("cap")(
                                                          _vm.$t(
                                                            "defautFrontlanguage"
                                                          )
                                                        )
                                                      )
                                                    )
                                                  ])
                                                ],
                                                1
                                              )
                                            ],
                                            1
                                          )
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "v-expansion-panel-content",
                                        {
                                          attrs: {
                                            disabled: _vm.testBrideStatus(
                                              "parametre_apercu_title_close"
                                            )
                                          }
                                        },
                                        [
                                          _c(
                                            "div",
                                            {
                                              attrs: { slot: "header" },
                                              slot: "header"
                                            },
                                            [
                                              _c(
                                                "v-icon",
                                                {
                                                  staticClass:
                                                    "mr-2 primary--text"
                                                },
                                                [_vm._v("title")]
                                              ),
                                              _vm._v(
                                                "\n                  " +
                                                  _vm._s(
                                                    _vm._f("cap")(
                                                      _vm.$t("widgetTitle")
                                                    )
                                                  ) +
                                                  "\n                "
                                              )
                                            ],
                                            1
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "v-card",
                                            [
                                              _c(
                                                "v-card-text",
                                                _vm._l(_vm.langs, function(
                                                  l,
                                                  i
                                                ) {
                                                  return _c("v-text-field", {
                                                    key: i,
                                                    attrs: { label: l.text },
                                                    model: {
                                                      value:
                                                        _vm.options
                                                          .DSK_TAB_MSG_JSON[
                                                          l.value
                                                        ],
                                                      callback: function($$v) {
                                                        _vm.$set(
                                                          _vm.options
                                                            .DSK_TAB_MSG_JSON,
                                                          l.value,
                                                          $$v
                                                        )
                                                      },
                                                      expression:
                                                        "options.DSK_TAB_MSG_JSON[l.value]"
                                                    }
                                                  })
                                                }),
                                                1
                                              )
                                            ],
                                            1
                                          )
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "v-expansion-panel-content",
                                        {
                                          attrs: {
                                            disabled: _vm.testBrideStatus(
                                              "parametre_apercu_title_offline"
                                            )
                                          },
                                          nativeOn: {
                                            click: function($event) {
                                              $event.stopPropagation()
                                              return _vm.agenttOnline()
                                            }
                                          }
                                        },
                                        [
                                          _c(
                                            "div",
                                            {
                                              attrs: { slot: "header" },
                                              slot: "header"
                                            },
                                            [
                                              _c(
                                                "v-icon",
                                                {
                                                  staticClass:
                                                    "mr-2 primary--text"
                                                },
                                                [_vm._v("title")]
                                              ),
                                              _vm._v(
                                                "\n                  " +
                                                  _vm._s(
                                                    _vm._f("cap")(
                                                      _vm.$t(
                                                        "widgetSubTitleOffline"
                                                      )
                                                    )
                                                  ) +
                                                  "\n                "
                                              )
                                            ],
                                            1
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "v-card",
                                            [
                                              _c(
                                                "v-card-text",
                                                _vm._l(_vm.langs, function(
                                                  l,
                                                  i
                                                ) {
                                                  return _c("v-text-field", {
                                                    key: i,
                                                    attrs: { label: l.text },
                                                    model: {
                                                      value:
                                                        _vm.options
                                                          .DSK_TAB_MSG_JSON2[
                                                          l.value
                                                        ],
                                                      callback: function($$v) {
                                                        _vm.$set(
                                                          _vm.options
                                                            .DSK_TAB_MSG_JSON2,
                                                          l.value,
                                                          $$v
                                                        )
                                                      },
                                                      expression:
                                                        "options.DSK_TAB_MSG_JSON2[l.value]"
                                                    }
                                                  })
                                                }),
                                                1
                                              )
                                            ],
                                            1
                                          )
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "v-expansion-panel-content",
                                        {
                                          attrs: {
                                            disabled: _vm.testBrideStatus(
                                              "parametre_apercu_title_online"
                                            )
                                          },
                                          nativeOn: {
                                            click: function($event) {
                                              $event.stopPropagation()
                                              return _vm.agenttOffline()
                                            }
                                          }
                                        },
                                        [
                                          _c(
                                            "div",
                                            {
                                              attrs: { slot: "header" },
                                              slot: "header"
                                            },
                                            [
                                              _c(
                                                "v-icon",
                                                {
                                                  staticClass:
                                                    "mr-2 primary--text"
                                                },
                                                [_vm._v("title")]
                                              ),
                                              _vm._v(
                                                "\n                  " +
                                                  _vm._s(
                                                    _vm._f("cap")(
                                                      _vm.$t(
                                                        "widgetSubTitleOnline"
                                                      )
                                                    )
                                                  ) +
                                                  "\n                "
                                              )
                                            ],
                                            1
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "v-card",
                                            [
                                              _c(
                                                "v-card-text",
                                                _vm._l(_vm.langs, function(
                                                  l,
                                                  i
                                                ) {
                                                  return _c("v-text-field", {
                                                    key: i,
                                                    attrs: { label: l.text },
                                                    model: {
                                                      value:
                                                        _vm.options
                                                          .DSK_TAB_MSG_JSON3[
                                                          l.value
                                                        ],
                                                      callback: function($$v) {
                                                        _vm.$set(
                                                          _vm.options
                                                            .DSK_TAB_MSG_JSON3,
                                                          l.value,
                                                          $$v
                                                        )
                                                      },
                                                      expression:
                                                        "options.DSK_TAB_MSG_JSON3[l.value]"
                                                    }
                                                  })
                                                }),
                                                1
                                              )
                                            ],
                                            1
                                          )
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "v-expansion-panel-content",
                            [
                              _c(
                                "div",
                                { attrs: { slot: "header" }, slot: "header" },
                                [
                                  _c(
                                    "v-icon",
                                    { staticClass: "mr-2 primary--text" },
                                    [_vm._v("settings_applications")]
                                  ),
                                  _vm._v(
                                    "\n              " +
                                      _vm._s(_vm.$t("previewRestrict")) +
                                      "\n              "
                                  ),
                                  _c(
                                    "v-tooltip",
                                    {
                                      attrs: { bottom: "" },
                                      nativeOn: {
                                        click: function($event) {
                                          $event.stopPropagation()
                                          _vm.openDialog({
                                            title: _vm.$t("previewAfficher"),
                                            content: _vm.$t(
                                              "previewRestricDesc"
                                            )
                                          })
                                        }
                                      }
                                    },
                                    [
                                      _c(
                                        "template",
                                        { slot: "activator" },
                                        [
                                          _c(
                                            "v-icon",
                                            {
                                              staticClass: "infos",
                                              attrs: {
                                                color: "grey lighten-1",
                                                dark: ""
                                              }
                                            },
                                            [_vm._v("info")]
                                          )
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c("span", [
                                        _vm._v(_vm._s(_vm.$t("enSavoirPlus")))
                                      ])
                                    ],
                                    2
                                  )
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "v-card",
                                { staticClass: "ml-3" },
                                [
                                  _c(
                                    "v-expansion-panel",
                                    [
                                      _c(
                                        "v-expansion-panel-content",
                                        {
                                          attrs: {
                                            disabled: _vm.testBrideStatus(
                                              "parametre_affichage_horaire"
                                            )
                                          },
                                          nativeOn: {
                                            click: function($event) {
                                              return _vm.loadImg(false)
                                            }
                                          }
                                        },
                                        [
                                          _c(
                                            "div",
                                            {
                                              attrs: { slot: "header" },
                                              slot: "header"
                                            },
                                            [
                                              _c(
                                                "v-icon",
                                                {
                                                  staticClass:
                                                    "mr-2 primary--text"
                                                },
                                                [_vm._v("schedule")]
                                              ),
                                              _vm._v(
                                                "\n                  " +
                                                  _vm._s(
                                                    _vm._f("cap")(
                                                      _vm.$t("displayTimes")
                                                    )
                                                  ) +
                                                  "\n                "
                                              )
                                            ],
                                            1
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "v-card",
                                            [
                                              _c(
                                                "v-card-text",
                                                [
                                                  _c(
                                                    "v-layout",
                                                    [
                                                      _c(
                                                        "v-flex",
                                                        {
                                                          attrs: {
                                                            xs12: "",
                                                            sm12: "",
                                                            md6: ""
                                                          }
                                                        },
                                                        [
                                                          _c(
                                                            "v-radio-group",
                                                            {
                                                              attrs: {
                                                                hint: _vm.$t(
                                                                  "defineWidgetHours"
                                                                ),
                                                                "persistent-hint":
                                                                  ""
                                                              },
                                                              model: {
                                                                value:
                                                                  _vm.form
                                                                    .hours,
                                                                callback: function(
                                                                  $$v
                                                                ) {
                                                                  _vm.$set(
                                                                    _vm.form,
                                                                    "hours",
                                                                    $$v
                                                                  )
                                                                },
                                                                expression:
                                                                  "form.hours"
                                                              }
                                                            },
                                                            [
                                                              _c("v-radio", {
                                                                attrs: {
                                                                  label: _vm._f(
                                                                    "cap"
                                                                  )(
                                                                    _vm.$t(
                                                                      "allTheTime"
                                                                    )
                                                                  ),
                                                                  color:
                                                                    "primary",
                                                                  value: "all"
                                                                }
                                                              }),
                                                              _vm._v(" "),
                                                              _c("v-radio", {
                                                                attrs: {
                                                                  label: _vm._f(
                                                                    "cap"
                                                                  )(
                                                                    _vm.$t(
                                                                      "customHours"
                                                                    )
                                                                  ),
                                                                  color:
                                                                    "primary",
                                                                  value:
                                                                    "defined"
                                                                }
                                                              })
                                                            ],
                                                            1
                                                          )
                                                        ],
                                                        1
                                                      )
                                                    ],
                                                    1
                                                  ),
                                                  _vm._v(" "),
                                                  _vm.form.hours == "defined"
                                                    ? _c(
                                                        "v-layout",
                                                        {
                                                          attrs: {
                                                            row: "",
                                                            wrap: ""
                                                          }
                                                        },
                                                        [
                                                          _c(
                                                            "v-flex",
                                                            {
                                                              attrs: {
                                                                xs12: ""
                                                              }
                                                            },
                                                            [
                                                              _c(
                                                                "v-btn",
                                                                {
                                                                  staticClass:
                                                                    "primary--text",
                                                                  attrs: {
                                                                    flat: ""
                                                                  },
                                                                  on: {
                                                                    click: function(
                                                                      $event
                                                                    ) {
                                                                      return _vm.openHours()
                                                                    }
                                                                  }
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    _vm._s(
                                                                      _vm.$t(
                                                                        "timesSeveralDays"
                                                                      )
                                                                    )
                                                                  ),
                                                                  _c(
                                                                    "v-icon",
                                                                    {
                                                                      attrs: {
                                                                        right:
                                                                          ""
                                                                      }
                                                                    },
                                                                    [
                                                                      _vm._v(
                                                                        "event"
                                                                      )
                                                                    ]
                                                                  )
                                                                ],
                                                                1
                                                              )
                                                            ],
                                                            1
                                                          ),
                                                          _vm._v(" "),
                                                          _c(
                                                            "v-expansion-panel",
                                                            _vm._l(
                                                              _vm.form.days,
                                                              function(day) {
                                                                return _c(
                                                                  "v-expansion-panel-content",
                                                                  {
                                                                    key:
                                                                      day.name
                                                                  },
                                                                  [
                                                                    _c(
                                                                      "v-layout",
                                                                      {
                                                                        attrs: {
                                                                          slot:
                                                                            "header",
                                                                          "align-center":
                                                                            "",
                                                                          row:
                                                                            "",
                                                                          spacer:
                                                                            ""
                                                                        },
                                                                        slot:
                                                                          "header"
                                                                      },
                                                                      [
                                                                        _c(
                                                                          "v-flex",
                                                                          {
                                                                            attrs: {
                                                                              xs12:
                                                                                ""
                                                                            }
                                                                          },
                                                                          [
                                                                            _c(
                                                                              "span",
                                                                              {
                                                                                staticClass:
                                                                                  "hidden-md-and-up"
                                                                              },
                                                                              [
                                                                                _vm._v(
                                                                                  _vm._s(
                                                                                    day.name.substring(
                                                                                      0,
                                                                                      3
                                                                                    )
                                                                                  ) +
                                                                                    ". : "
                                                                                )
                                                                              ]
                                                                            ),
                                                                            _vm._v(
                                                                              " "
                                                                            ),
                                                                            _c(
                                                                              "span",
                                                                              {
                                                                                staticClass:
                                                                                  "hidden-sm-and-down"
                                                                              },
                                                                              [
                                                                                _vm._v(
                                                                                  _vm._s(
                                                                                    day.name
                                                                                  ) +
                                                                                    " : "
                                                                                )
                                                                              ]
                                                                            ),
                                                                            _vm._v(
                                                                              " "
                                                                            ),
                                                                            day
                                                                              .am
                                                                              .active ||
                                                                            day
                                                                              .pm
                                                                              .active
                                                                              ? _c(
                                                                                  "span",
                                                                                  [
                                                                                    day
                                                                                      .am
                                                                                      .active
                                                                                      ? _c(
                                                                                          "span",
                                                                                          [
                                                                                            _vm._v(
                                                                                              " " +
                                                                                                _vm._s(
                                                                                                  _vm.$t(
                                                                                                    "from"
                                                                                                  )
                                                                                                )
                                                                                            ),
                                                                                            _c(
                                                                                              "code",
                                                                                              [
                                                                                                _vm._v(
                                                                                                  _vm._s(
                                                                                                    day
                                                                                                      .am
                                                                                                      .start
                                                                                                  )
                                                                                                )
                                                                                              ]
                                                                                            ),
                                                                                            _vm._v(
                                                                                              " " +
                                                                                                _vm._s(
                                                                                                  _vm.$t(
                                                                                                    "to"
                                                                                                  )
                                                                                                ) +
                                                                                                " "
                                                                                            ),
                                                                                            _c(
                                                                                              "code",
                                                                                              [
                                                                                                _vm._v(
                                                                                                  _vm._s(
                                                                                                    day
                                                                                                      .am
                                                                                                      .end
                                                                                                  )
                                                                                                )
                                                                                              ]
                                                                                            )
                                                                                          ]
                                                                                        )
                                                                                      : _vm._e(),
                                                                                    _vm._v(
                                                                                      " "
                                                                                    ),
                                                                                    day
                                                                                      .am
                                                                                      .active &&
                                                                                    day
                                                                                      .pm
                                                                                      .active
                                                                                      ? _c(
                                                                                          "span",
                                                                                          [
                                                                                            _vm._v(
                                                                                              " " +
                                                                                                _vm._s(
                                                                                                  _vm.$t(
                                                                                                    "and"
                                                                                                  )
                                                                                                )
                                                                                            )
                                                                                          ]
                                                                                        )
                                                                                      : _vm._e(),
                                                                                    _vm._v(
                                                                                      " "
                                                                                    ),
                                                                                    day
                                                                                      .pm
                                                                                      .active
                                                                                      ? _c(
                                                                                          "span",
                                                                                          [
                                                                                            _vm._v(
                                                                                              _vm._s(
                                                                                                _vm.$t(
                                                                                                  "from"
                                                                                                )
                                                                                              ) +
                                                                                                " "
                                                                                            ),
                                                                                            _c(
                                                                                              "code",
                                                                                              [
                                                                                                _vm._v(
                                                                                                  _vm._s(
                                                                                                    day
                                                                                                      .pm
                                                                                                      .start
                                                                                                  )
                                                                                                )
                                                                                              ]
                                                                                            ),
                                                                                            _vm._v(
                                                                                              " " +
                                                                                                _vm._s(
                                                                                                  _vm.$t(
                                                                                                    "to"
                                                                                                  )
                                                                                                ) +
                                                                                                " "
                                                                                            ),
                                                                                            _c(
                                                                                              "code",
                                                                                              [
                                                                                                _vm._v(
                                                                                                  _vm._s(
                                                                                                    day
                                                                                                      .pm
                                                                                                      .end
                                                                                                  )
                                                                                                )
                                                                                              ]
                                                                                            )
                                                                                          ]
                                                                                        )
                                                                                      : _vm._e()
                                                                                  ]
                                                                                )
                                                                              : _c(
                                                                                  "span",
                                                                                  [
                                                                                    _c(
                                                                                      "span",
                                                                                      [
                                                                                        _vm._v(
                                                                                          _vm._s(
                                                                                            _vm._f(
                                                                                              "cap"
                                                                                            )(
                                                                                              _vm.$t(
                                                                                                "disabledToday"
                                                                                              )
                                                                                            )
                                                                                          )
                                                                                        )
                                                                                      ]
                                                                                    )
                                                                                  ]
                                                                                )
                                                                          ]
                                                                        )
                                                                      ],
                                                                      1
                                                                    ),
                                                                    _vm._v(" "),
                                                                    _c(
                                                                      "v-card",
                                                                      {
                                                                        staticClass:
                                                                          "grey lighten-3"
                                                                      },
                                                                      [
                                                                        _c(
                                                                          "v-card-text",
                                                                          [
                                                                            _c(
                                                                              "v-layout",
                                                                              {
                                                                                attrs: {
                                                                                  row:
                                                                                    "",
                                                                                  wrap:
                                                                                    ""
                                                                                }
                                                                              },
                                                                              [
                                                                                _c(
                                                                                  "v-flex",
                                                                                  {
                                                                                    attrs: {
                                                                                      xs12:
                                                                                        "",
                                                                                      sm6:
                                                                                        "",
                                                                                      md2:
                                                                                        ""
                                                                                    }
                                                                                  },
                                                                                  [
                                                                                    _c(
                                                                                      "v-switch",
                                                                                      {
                                                                                        attrs: {
                                                                                          label: _vm._f(
                                                                                            "cap"
                                                                                          )(
                                                                                            _vm.$t(
                                                                                              "activateMorning"
                                                                                            )
                                                                                          ),
                                                                                          light:
                                                                                            "",
                                                                                          color:
                                                                                            "primary"
                                                                                        },
                                                                                        model: {
                                                                                          value:
                                                                                            day
                                                                                              .am
                                                                                              .active,
                                                                                          callback: function(
                                                                                            $$v
                                                                                          ) {
                                                                                            _vm.$set(
                                                                                              day.am,
                                                                                              "active",
                                                                                              $$v
                                                                                            )
                                                                                          },
                                                                                          expression:
                                                                                            "day.am.active"
                                                                                        }
                                                                                      }
                                                                                    )
                                                                                  ],
                                                                                  1
                                                                                ),
                                                                                _vm._v(
                                                                                  " "
                                                                                ),
                                                                                _c(
                                                                                  "v-flex",
                                                                                  {
                                                                                    attrs: {
                                                                                      xs12:
                                                                                        "",
                                                                                      sm6:
                                                                                        "",
                                                                                      md2:
                                                                                        ""
                                                                                    }
                                                                                  },
                                                                                  [
                                                                                    _c(
                                                                                      "v-text-field",
                                                                                      {
                                                                                        attrs: {
                                                                                          slot:
                                                                                            "activator",
                                                                                          label:
                                                                                            _vm.$t(
                                                                                              "from"
                                                                                            ) +
                                                                                            " " +
                                                                                            day.name +
                                                                                            " " +
                                                                                            _vm.$t(
                                                                                              "morning"
                                                                                            ),
                                                                                          "prepend-icon":
                                                                                            "access_time",
                                                                                          disabled: !day
                                                                                            .am
                                                                                            .active,
                                                                                          readonly:
                                                                                            ""
                                                                                        },
                                                                                        on: {
                                                                                          click: function(
                                                                                            $event
                                                                                          ) {
                                                                                            return _vm.openTimePicker(
                                                                                              day,
                                                                                              "am",
                                                                                              "start"
                                                                                            )
                                                                                          }
                                                                                        },
                                                                                        slot:
                                                                                          "activator",
                                                                                        model: {
                                                                                          value:
                                                                                            day
                                                                                              .am
                                                                                              .start,
                                                                                          callback: function(
                                                                                            $$v
                                                                                          ) {
                                                                                            _vm.$set(
                                                                                              day.am,
                                                                                              "start",
                                                                                              $$v
                                                                                            )
                                                                                          },
                                                                                          expression:
                                                                                            "day.am.start"
                                                                                        }
                                                                                      }
                                                                                    )
                                                                                  ],
                                                                                  1
                                                                                ),
                                                                                _vm._v(
                                                                                  " "
                                                                                ),
                                                                                _c(
                                                                                  "v-flex",
                                                                                  {
                                                                                    attrs: {
                                                                                      xs12:
                                                                                        "",
                                                                                      sm6:
                                                                                        "",
                                                                                      md2:
                                                                                        ""
                                                                                    }
                                                                                  },
                                                                                  [
                                                                                    _c(
                                                                                      "v-text-field",
                                                                                      {
                                                                                        attrs: {
                                                                                          slot:
                                                                                            "activator",
                                                                                          label:
                                                                                            _vm.$t(
                                                                                              "to"
                                                                                            ) +
                                                                                            " " +
                                                                                            day.name +
                                                                                            " " +
                                                                                            _vm.$t(
                                                                                              "morning"
                                                                                            ),
                                                                                          "prepend-icon":
                                                                                            "access_time",
                                                                                          disabled: !day
                                                                                            .am
                                                                                            .active,
                                                                                          readonly:
                                                                                            ""
                                                                                        },
                                                                                        on: {
                                                                                          click: function(
                                                                                            $event
                                                                                          ) {
                                                                                            return _vm.openTimePicker(
                                                                                              day,
                                                                                              "am",
                                                                                              "end"
                                                                                            )
                                                                                          }
                                                                                        },
                                                                                        slot:
                                                                                          "activator",
                                                                                        model: {
                                                                                          value:
                                                                                            day
                                                                                              .am
                                                                                              .end,
                                                                                          callback: function(
                                                                                            $$v
                                                                                          ) {
                                                                                            _vm.$set(
                                                                                              day.am,
                                                                                              "end",
                                                                                              $$v
                                                                                            )
                                                                                          },
                                                                                          expression:
                                                                                            "day.am.end"
                                                                                        }
                                                                                      }
                                                                                    )
                                                                                  ],
                                                                                  1
                                                                                )
                                                                              ],
                                                                              1
                                                                            ),
                                                                            _vm._v(
                                                                              " "
                                                                            ),
                                                                            _c(
                                                                              "v-layout",
                                                                              {
                                                                                attrs: {
                                                                                  row:
                                                                                    "",
                                                                                  wrap:
                                                                                    ""
                                                                                }
                                                                              },
                                                                              [
                                                                                _c(
                                                                                  "v-flex",
                                                                                  {
                                                                                    attrs: {
                                                                                      xs12:
                                                                                        "",
                                                                                      sm6:
                                                                                        "",
                                                                                      md2:
                                                                                        ""
                                                                                    }
                                                                                  },
                                                                                  [
                                                                                    _c(
                                                                                      "v-switch",
                                                                                      {
                                                                                        attrs: {
                                                                                          label: _vm._f(
                                                                                            "cap"
                                                                                          )(
                                                                                            _vm.$t(
                                                                                              "activateAfternoon"
                                                                                            )
                                                                                          ),
                                                                                          light:
                                                                                            "",
                                                                                          color:
                                                                                            "primary"
                                                                                        },
                                                                                        model: {
                                                                                          value:
                                                                                            day
                                                                                              .pm
                                                                                              .active,
                                                                                          callback: function(
                                                                                            $$v
                                                                                          ) {
                                                                                            _vm.$set(
                                                                                              day.pm,
                                                                                              "active",
                                                                                              $$v
                                                                                            )
                                                                                          },
                                                                                          expression:
                                                                                            "day.pm.active"
                                                                                        }
                                                                                      }
                                                                                    )
                                                                                  ],
                                                                                  1
                                                                                ),
                                                                                _vm._v(
                                                                                  " "
                                                                                ),
                                                                                _c(
                                                                                  "v-flex",
                                                                                  {
                                                                                    attrs: {
                                                                                      xs12:
                                                                                        "",
                                                                                      sm6:
                                                                                        "",
                                                                                      md2:
                                                                                        ""
                                                                                    }
                                                                                  },
                                                                                  [
                                                                                    _c(
                                                                                      "v-text-field",
                                                                                      {
                                                                                        attrs: {
                                                                                          slot:
                                                                                            "activator",
                                                                                          label:
                                                                                            _vm.$t(
                                                                                              "from"
                                                                                            ) +
                                                                                            " " +
                                                                                            day.name +
                                                                                            " " +
                                                                                            _vm.$t(
                                                                                              "afternoon"
                                                                                            ),
                                                                                          "prepend-icon":
                                                                                            "access_time",
                                                                                          disabled: !day
                                                                                            .pm
                                                                                            .active,
                                                                                          readonly:
                                                                                            ""
                                                                                        },
                                                                                        on: {
                                                                                          click: function(
                                                                                            $event
                                                                                          ) {
                                                                                            return _vm.openTimePicker(
                                                                                              day,
                                                                                              "pm",
                                                                                              "start"
                                                                                            )
                                                                                          }
                                                                                        },
                                                                                        slot:
                                                                                          "activator",
                                                                                        model: {
                                                                                          value:
                                                                                            day
                                                                                              .pm
                                                                                              .start,
                                                                                          callback: function(
                                                                                            $$v
                                                                                          ) {
                                                                                            _vm.$set(
                                                                                              day.pm,
                                                                                              "start",
                                                                                              $$v
                                                                                            )
                                                                                          },
                                                                                          expression:
                                                                                            "day.pm.start"
                                                                                        }
                                                                                      }
                                                                                    )
                                                                                  ],
                                                                                  1
                                                                                ),
                                                                                _vm._v(
                                                                                  " "
                                                                                ),
                                                                                _c(
                                                                                  "v-flex",
                                                                                  {
                                                                                    attrs: {
                                                                                      xs12:
                                                                                        "",
                                                                                      sm6:
                                                                                        "",
                                                                                      md2:
                                                                                        ""
                                                                                    }
                                                                                  },
                                                                                  [
                                                                                    _c(
                                                                                      "v-text-field",
                                                                                      {
                                                                                        attrs: {
                                                                                          slot:
                                                                                            "activator",
                                                                                          label:
                                                                                            _vm.$t(
                                                                                              "to"
                                                                                            ) +
                                                                                            " " +
                                                                                            day.name +
                                                                                            " " +
                                                                                            _vm.$t(
                                                                                              "afternoon"
                                                                                            ),
                                                                                          "prepend-icon":
                                                                                            "access_time",
                                                                                          disabled: !day
                                                                                            .pm
                                                                                            .active,
                                                                                          readonly:
                                                                                            ""
                                                                                        },
                                                                                        on: {
                                                                                          click: function(
                                                                                            $event
                                                                                          ) {
                                                                                            return _vm.openTimePicker(
                                                                                              day,
                                                                                              "pm",
                                                                                              "end"
                                                                                            )
                                                                                          }
                                                                                        },
                                                                                        slot:
                                                                                          "activator",
                                                                                        model: {
                                                                                          value:
                                                                                            day
                                                                                              .pm
                                                                                              .end,
                                                                                          callback: function(
                                                                                            $$v
                                                                                          ) {
                                                                                            _vm.$set(
                                                                                              day.pm,
                                                                                              "end",
                                                                                              $$v
                                                                                            )
                                                                                          },
                                                                                          expression:
                                                                                            "day.pm.end"
                                                                                        }
                                                                                      }
                                                                                    )
                                                                                  ],
                                                                                  1
                                                                                )
                                                                              ],
                                                                              1
                                                                            )
                                                                          ],
                                                                          1
                                                                        )
                                                                      ],
                                                                      1
                                                                    )
                                                                  ],
                                                                  1
                                                                )
                                                              }
                                                            ),
                                                            1
                                                          )
                                                        ],
                                                        1
                                                      )
                                                    : _vm._e()
                                                ],
                                                1
                                              )
                                            ],
                                            1
                                          )
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "v-expansion-panel-content",
                                        {
                                          attrs: {
                                            disabled: _vm.testBrideStatus(
                                              "parametre_affichage_url"
                                            )
                                          }
                                        },
                                        [
                                          _c(
                                            "div",
                                            {
                                              attrs: { slot: "header" },
                                              slot: "header"
                                            },
                                            [
                                              _c(
                                                "v-icon",
                                                {
                                                  staticClass:
                                                    "mr-2 primary--text"
                                                },
                                                [_vm._v("language")]
                                              ),
                                              _vm._v(
                                                _vm._s(
                                                  _vm._f("cap")(
                                                    _vm.$t("urlDisplay")
                                                  )
                                                )
                                              )
                                            ],
                                            1
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "v-card",
                                            { staticClass: "mb-3" },
                                            [
                                              _c(
                                                "v-card-text",
                                                [
                                                  _c(
                                                    "v-layout",
                                                    [
                                                      _c(
                                                        "v-flex",
                                                        { attrs: { xs12: "" } },
                                                        [
                                                          _c(
                                                            "v-radio-group",
                                                            {
                                                              attrs: {
                                                                hint: _vm.$t(
                                                                  "chooseWhiteOrBlack"
                                                                ),
                                                                "persistent-hint":
                                                                  ""
                                                              },
                                                              model: {
                                                                value:
                                                                  _vm.form.urls,
                                                                callback: function(
                                                                  $$v
                                                                ) {
                                                                  _vm.$set(
                                                                    _vm.form,
                                                                    "urls",
                                                                    $$v
                                                                  )
                                                                },
                                                                expression:
                                                                  "form.urls"
                                                              }
                                                            },
                                                            [
                                                              _c("v-radio", {
                                                                attrs: {
                                                                  label: _vm._f(
                                                                    "cap"
                                                                  )(
                                                                    _vm.$t(
                                                                      "everywhere"
                                                                    )
                                                                  ),
                                                                  color:
                                                                    "primary",
                                                                  value: "all"
                                                                }
                                                              }),
                                                              _vm._v(" "),
                                                              _c("v-radio", {
                                                                attrs: {
                                                                  label:
                                                                    "White List",
                                                                  color:
                                                                    "primary",
                                                                  value:
                                                                    "showOnOff"
                                                                }
                                                              }),
                                                              _vm._v(" "),
                                                              _c("v-radio", {
                                                                attrs: {
                                                                  label:
                                                                    "Black List",
                                                                  color:
                                                                    "primary",
                                                                  value:
                                                                    "hideOnOff"
                                                                }
                                                              })
                                                            ],
                                                            1
                                                          )
                                                        ],
                                                        1
                                                      )
                                                    ],
                                                    1
                                                  ),
                                                  _vm._v(" "),
                                                  _c(
                                                    "v-layout",
                                                    {
                                                      directives: [
                                                        {
                                                          name: "show",
                                                          rawName: "v-show",
                                                          value:
                                                            _vm.form.urls !=
                                                            "all",
                                                          expression:
                                                            "form.urls != 'all'"
                                                        }
                                                      ],
                                                      attrs: {
                                                        row: "",
                                                        wrap: ""
                                                      }
                                                    },
                                                    [
                                                      _c(
                                                        "v-flex",
                                                        { attrs: { xs12: "" } },
                                                        [
                                                          _c(
                                                            "v-card",
                                                            [
                                                              _c(
                                                                "v-card-text",
                                                                [
                                                                  _c(
                                                                    "v-fab-transition",
                                                                    {
                                                                      attrs: {
                                                                        slot:
                                                                          "activator"
                                                                      },
                                                                      slot:
                                                                        "activator"
                                                                    },
                                                                    [
                                                                      _c(
                                                                        "v-btn",
                                                                        {
                                                                          directives: [
                                                                            {
                                                                              name:
                                                                                "show",
                                                                              rawName:
                                                                                "v-show",
                                                                              value:
                                                                                _vm
                                                                                  .form
                                                                                  .urls !=
                                                                                "all",
                                                                              expression:
                                                                                "form.urls != 'all'"
                                                                            }
                                                                          ],
                                                                          staticClass:
                                                                            "secondary",
                                                                          attrs: {
                                                                            dark:
                                                                              "",
                                                                            absolute:
                                                                              "",
                                                                            top:
                                                                              "",
                                                                            right:
                                                                              "",
                                                                            fab:
                                                                              ""
                                                                          },
                                                                          on: {
                                                                            click: function(
                                                                              $event
                                                                            ) {
                                                                              $event.stopPropagation()
                                                                              return _vm.openRule()
                                                                            }
                                                                          }
                                                                        },
                                                                        [
                                                                          _c(
                                                                            "v-icon",
                                                                            [
                                                                              _vm._v(
                                                                                "add"
                                                                              )
                                                                            ]
                                                                          )
                                                                        ],
                                                                        1
                                                                      )
                                                                    ],
                                                                    1
                                                                  ),
                                                                  _vm._v(" "),
                                                                  _c(
                                                                    "v-data-table",
                                                                    {
                                                                      attrs: {
                                                                        headers:
                                                                          _vm.headersRules,
                                                                        items:
                                                                          _vm
                                                                            .form
                                                                            .rules,
                                                                        "no-data-text": _vm.$t(
                                                                          "noRules"
                                                                        ),
                                                                        "hide-actions":
                                                                          ""
                                                                      },
                                                                      scopedSlots: _vm._u(
                                                                        [
                                                                          {
                                                                            key:
                                                                              "items",
                                                                            fn: function(
                                                                              props
                                                                            ) {
                                                                              return [
                                                                                props
                                                                                  .item
                                                                                  .list ===
                                                                                _vm
                                                                                  .form
                                                                                  .urls
                                                                                  ? _c(
                                                                                      "td",
                                                                                      [
                                                                                        _c(
                                                                                          "v-edit-dialog",
                                                                                          {
                                                                                            attrs: {
                                                                                              "return-value":
                                                                                                props
                                                                                                  .item
                                                                                                  .type,
                                                                                              "cancel-text": _vm.$t(
                                                                                                "cancel"
                                                                                              ),
                                                                                              "save-text": _vm.$t(
                                                                                                "submit"
                                                                                              ),
                                                                                              large:
                                                                                                ""
                                                                                            },
                                                                                            on: {
                                                                                              "update:returnValue": function(
                                                                                                $event
                                                                                              ) {
                                                                                                return _vm.$set(
                                                                                                  props.item,
                                                                                                  "type",
                                                                                                  $event
                                                                                                )
                                                                                              },
                                                                                              "update:return-value": function(
                                                                                                $event
                                                                                              ) {
                                                                                                return _vm.$set(
                                                                                                  props.item,
                                                                                                  "type",
                                                                                                  $event
                                                                                                )
                                                                                              }
                                                                                            }
                                                                                          },
                                                                                          [
                                                                                            _c(
                                                                                              "div",
                                                                                              [
                                                                                                _vm._v(
                                                                                                  _vm._s(
                                                                                                    props
                                                                                                      .item
                                                                                                      .type
                                                                                                      .text
                                                                                                  )
                                                                                                )
                                                                                              ]
                                                                                            ),
                                                                                            _vm._v(
                                                                                              " "
                                                                                            ),
                                                                                            _c(
                                                                                              "div",
                                                                                              {
                                                                                                staticClass:
                                                                                                  "mt-3 title",
                                                                                                attrs: {
                                                                                                  slot:
                                                                                                    "input"
                                                                                                },
                                                                                                slot:
                                                                                                  "input"
                                                                                              },
                                                                                              [
                                                                                                _vm._v(
                                                                                                  _vm._s(
                                                                                                    _vm.$t(
                                                                                                      "changeType"
                                                                                                    )
                                                                                                  )
                                                                                                )
                                                                                              ]
                                                                                            ),
                                                                                            _vm._v(
                                                                                              " "
                                                                                            ),
                                                                                            _c(
                                                                                              "v-select",
                                                                                              {
                                                                                                attrs: {
                                                                                                  slot:
                                                                                                    "input",
                                                                                                  items:
                                                                                                    _vm.typeRules,
                                                                                                  "return-object":
                                                                                                    "",
                                                                                                  autofocus:
                                                                                                    ""
                                                                                                },
                                                                                                slot:
                                                                                                  "input",
                                                                                                model: {
                                                                                                  value:
                                                                                                    props
                                                                                                      .item
                                                                                                      .type,
                                                                                                  callback: function(
                                                                                                    $$v
                                                                                                  ) {
                                                                                                    _vm.$set(
                                                                                                      props.item,
                                                                                                      "type",
                                                                                                      $$v
                                                                                                    )
                                                                                                  },
                                                                                                  expression:
                                                                                                    "props.item.type"
                                                                                                }
                                                                                              }
                                                                                            )
                                                                                          ],
                                                                                          1
                                                                                        )
                                                                                      ],
                                                                                      1
                                                                                    )
                                                                                  : _vm._e(),
                                                                                _vm._v(
                                                                                  " "
                                                                                ),
                                                                                props
                                                                                  .item
                                                                                  .list ===
                                                                                _vm
                                                                                  .form
                                                                                  .urls
                                                                                  ? _c(
                                                                                      "td",
                                                                                      [
                                                                                        _c(
                                                                                          "v-edit-dialog",
                                                                                          {
                                                                                            attrs: {
                                                                                              "cancel-text": _vm.$t(
                                                                                                "cancel"
                                                                                              ),
                                                                                              "save-text": _vm.$t(
                                                                                                "submit"
                                                                                              ),
                                                                                              "return-value":
                                                                                                props
                                                                                                  .item
                                                                                                  .content,
                                                                                              large:
                                                                                                "",
                                                                                              lazy:
                                                                                                ""
                                                                                            },
                                                                                            on: {
                                                                                              "update:returnValue": function(
                                                                                                $event
                                                                                              ) {
                                                                                                return _vm.$set(
                                                                                                  props.item,
                                                                                                  "content",
                                                                                                  $event
                                                                                                )
                                                                                              },
                                                                                              "update:return-value": function(
                                                                                                $event
                                                                                              ) {
                                                                                                return _vm.$set(
                                                                                                  props.item,
                                                                                                  "content",
                                                                                                  $event
                                                                                                )
                                                                                              }
                                                                                            }
                                                                                          },
                                                                                          [
                                                                                            _c(
                                                                                              "div",
                                                                                              [
                                                                                                _c(
                                                                                                  "code",
                                                                                                  [
                                                                                                    _vm._v(
                                                                                                      _vm._s(
                                                                                                        props
                                                                                                          .item
                                                                                                          .content
                                                                                                      )
                                                                                                    )
                                                                                                  ]
                                                                                                )
                                                                                              ]
                                                                                            ),
                                                                                            _vm._v(
                                                                                              " "
                                                                                            ),
                                                                                            _c(
                                                                                              "div",
                                                                                              {
                                                                                                staticClass:
                                                                                                  "mt-3 title",
                                                                                                attrs: {
                                                                                                  slot:
                                                                                                    "input"
                                                                                                },
                                                                                                slot:
                                                                                                  "input"
                                                                                              },
                                                                                              [
                                                                                                _vm._v(
                                                                                                  _vm._s(
                                                                                                    _vm.$t(
                                                                                                      "editContent"
                                                                                                    )
                                                                                                  )
                                                                                                )
                                                                                              ]
                                                                                            ),
                                                                                            _vm._v(
                                                                                              " "
                                                                                            ),
                                                                                            _c(
                                                                                              "v-text-field",
                                                                                              {
                                                                                                attrs: {
                                                                                                  slot:
                                                                                                    "input",
                                                                                                  label:
                                                                                                    "Modification",
                                                                                                  "single-line":
                                                                                                    "",
                                                                                                  counter:
                                                                                                    "",
                                                                                                  autofocus:
                                                                                                    ""
                                                                                                },
                                                                                                slot:
                                                                                                  "input",
                                                                                                model: {
                                                                                                  value:
                                                                                                    props
                                                                                                      .item
                                                                                                      .content,
                                                                                                  callback: function(
                                                                                                    $$v
                                                                                                  ) {
                                                                                                    _vm.$set(
                                                                                                      props.item,
                                                                                                      "content",
                                                                                                      $$v
                                                                                                    )
                                                                                                  },
                                                                                                  expression:
                                                                                                    "props.item.content"
                                                                                                }
                                                                                              }
                                                                                            )
                                                                                          ],
                                                                                          1
                                                                                        )
                                                                                      ],
                                                                                      1
                                                                                    )
                                                                                  : _vm._e(),
                                                                                _vm._v(
                                                                                  " "
                                                                                ),
                                                                                props
                                                                                  .item
                                                                                  .list ===
                                                                                _vm
                                                                                  .form
                                                                                  .urls
                                                                                  ? _c(
                                                                                      "td",
                                                                                      {
                                                                                        staticClass:
                                                                                          "text-xs-right"
                                                                                      },
                                                                                      [
                                                                                        _c(
                                                                                          "v-btn",
                                                                                          {
                                                                                            attrs: {
                                                                                              icon:
                                                                                                "",
                                                                                              flat:
                                                                                                ""
                                                                                            },
                                                                                            on: {
                                                                                              click: function(
                                                                                                $event
                                                                                              ) {
                                                                                                $event.stopPropagation()
                                                                                                return _vm.deleteRule(
                                                                                                  props.index
                                                                                                )
                                                                                              }
                                                                                            }
                                                                                          },
                                                                                          [
                                                                                            _c(
                                                                                              "v-icon",
                                                                                              [
                                                                                                _vm._v(
                                                                                                  "delete"
                                                                                                )
                                                                                              ]
                                                                                            )
                                                                                          ],
                                                                                          1
                                                                                        )
                                                                                      ],
                                                                                      1
                                                                                    )
                                                                                  : _vm._e()
                                                                              ]
                                                                            }
                                                                          }
                                                                        ]
                                                                      )
                                                                    }
                                                                  )
                                                                ],
                                                                1
                                                              )
                                                            ],
                                                            1
                                                          )
                                                        ],
                                                        1
                                                      )
                                                    ],
                                                    1
                                                  )
                                                ],
                                                1
                                              )
                                            ],
                                            1
                                          )
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "v-expansion-panel-content",
                            [
                              _c(
                                "div",
                                { attrs: { slot: "header" }, slot: "header" },
                                [
                                  _c(
                                    "v-icon",
                                    { staticClass: "mr-2 primary--text" },
                                    [_vm._v("settings_applications")]
                                  ),
                                  _vm._v(
                                    "\n              " +
                                      _vm._s(_vm.$t("previewCondition")) +
                                      "\n              "
                                  ),
                                  _c(
                                    "v-tooltip",
                                    {
                                      attrs: { bottom: "" },
                                      nativeOn: {
                                        click: function($event) {
                                          $event.stopPropagation()
                                          _vm.openDialog({
                                            title: _vm.$t("previewCondAdd"),
                                            content: _vm.$t("previewConDesk")
                                          })
                                        }
                                      }
                                    },
                                    [
                                      _c(
                                        "template",
                                        { slot: "activator" },
                                        [
                                          _c(
                                            "v-icon",
                                            {
                                              staticClass: "infos",
                                              attrs: {
                                                color: "grey lighten-1",
                                                dark: ""
                                              }
                                            },
                                            [_vm._v("info")]
                                          )
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c("span", [
                                        _vm._v(_vm._s(_vm.$t("enSavoirPlus")))
                                      ])
                                    ],
                                    2
                                  )
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "v-card",
                                { staticClass: "ml-3" },
                                [
                                  _c(
                                    "v-expansion-panel",
                                    [
                                      _c(
                                        "v-expansion-panel-content",
                                        {
                                          attrs: {
                                            disabled: _vm.testBrideStatus(
                                              "parametre_affichage_perso"
                                            )
                                          },
                                          nativeOn: {
                                            click: function($event) {
                                              return _vm.loadImg(true)
                                            }
                                          }
                                        },
                                        [
                                          _c(
                                            "div",
                                            {
                                              attrs: { slot: "header" },
                                              slot: "header"
                                            },
                                            [
                                              _c(
                                                "v-icon",
                                                {
                                                  staticClass:
                                                    "mr-2 primary--text"
                                                },
                                                [
                                                  _vm._v(
                                                    "settings_applications"
                                                  )
                                                ]
                                              ),
                                              _vm._v(
                                                "\n                  " +
                                                  _vm._s(
                                                    _vm._f("cap")(
                                                      _vm.$t("customHours")
                                                    )
                                                  ) +
                                                  "\n                "
                                              )
                                            ],
                                            1
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "v-card",
                                            [
                                              _c(
                                                "v-card-text",
                                                [
                                                  _c(
                                                    "v-layout",
                                                    {
                                                      attrs: {
                                                        row: "",
                                                        wrap: ""
                                                      }
                                                    },
                                                    [
                                                      _c(
                                                        "v-flex",
                                                        { attrs: { xs12: "" } },
                                                        [
                                                          _c("v-switch", {
                                                            attrs: {
                                                              label: _vm._f(
                                                                "cap"
                                                              )(
                                                                _vm.$t(
                                                                  "hideOnMobile"
                                                                )
                                                              ),
                                                              light: "",
                                                              color: "primary"
                                                            },
                                                            model: {
                                                              value:
                                                                _vm.form
                                                                  .hiddenMobile,
                                                              callback: function(
                                                                $$v
                                                              ) {
                                                                _vm.$set(
                                                                  _vm.form,
                                                                  "hiddenMobile",
                                                                  $$v
                                                                )
                                                              },
                                                              expression:
                                                                "form.hiddenMobile"
                                                            }
                                                          })
                                                        ],
                                                        1
                                                      )
                                                    ],
                                                    1
                                                  ),
                                                  _vm._v(" "),
                                                  _c(
                                                    "v-layout",
                                                    [
                                                      _c(
                                                        "v-flex",
                                                        {
                                                          attrs: {
                                                            xs12: "",
                                                            md6: ""
                                                          }
                                                        },
                                                        [
                                                          _c("v-select", {
                                                            attrs: {
                                                              items:
                                                                _vm.optsDisplayDefault,
                                                              label: _vm._f(
                                                                "cap"
                                                              )(
                                                                _vm.$t(
                                                                  "defaultView"
                                                                )
                                                              ),
                                                              "return-object":
                                                                ""
                                                            },
                                                            model: {
                                                              value:
                                                                _vm.form
                                                                  .displayDefault,
                                                              callback: function(
                                                                $$v
                                                              ) {
                                                                _vm.$set(
                                                                  _vm.form,
                                                                  "displayDefault",
                                                                  $$v
                                                                )
                                                              },
                                                              expression:
                                                                "form.displayDefault"
                                                            }
                                                          })
                                                        ],
                                                        1
                                                      )
                                                    ],
                                                    1
                                                  ),
                                                  _vm._v(" "),
                                                  _c(
                                                    "v-layout",
                                                    [
                                                      _c(
                                                        "v-flex",
                                                        {
                                                          attrs: {
                                                            xs12: "",
                                                            md6: ""
                                                          }
                                                        },
                                                        [
                                                          _vm.form
                                                            .displayDefault
                                                            .value ==
                                                          "default_timeout"
                                                            ? _c(
                                                                "v-layout",
                                                                {
                                                                  attrs: {
                                                                    row: ""
                                                                  }
                                                                },
                                                                [
                                                                  _c(
                                                                    "v-flex",
                                                                    {
                                                                      attrs: {
                                                                        xs8: ""
                                                                      }
                                                                    },
                                                                    [
                                                                      _c(
                                                                        "v-slider",
                                                                        {
                                                                          attrs: {
                                                                            "thumb-label":
                                                                              "",
                                                                            min: 0,
                                                                            max: 300
                                                                          },
                                                                          model: {
                                                                            value:
                                                                              _vm
                                                                                .form
                                                                                .timeout,
                                                                            callback: function(
                                                                              $$v
                                                                            ) {
                                                                              _vm.$set(
                                                                                _vm.form,
                                                                                "timeout",
                                                                                $$v
                                                                              )
                                                                            },
                                                                            expression:
                                                                              "form.timeout"
                                                                          }
                                                                        }
                                                                      )
                                                                    ],
                                                                    1
                                                                  ),
                                                                  _vm._v(" "),
                                                                  _c(
                                                                    "v-flex",
                                                                    {
                                                                      attrs: {
                                                                        xs4: ""
                                                                      }
                                                                    },
                                                                    [
                                                                      _c(
                                                                        "v-subheader",
                                                                        [
                                                                          _vm._v(
                                                                            _vm._s(
                                                                              _vm
                                                                                .form
                                                                                .timeout
                                                                            ) +
                                                                              " sec."
                                                                          )
                                                                        ]
                                                                      )
                                                                    ],
                                                                    1
                                                                  )
                                                                ],
                                                                1
                                                              )
                                                            : _vm._e()
                                                        ],
                                                        1
                                                      )
                                                    ],
                                                    1
                                                  )
                                                ],
                                                1
                                              )
                                            ],
                                            1
                                          )
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "v-flex",
                    { attrs: { xs12: "", md6: "" } },
                    [
                      _c(
                        "v-tabs",
                        {
                          staticClass: "elevation-1",
                          attrs: {
                            "fixed-tabs": "",
                            centered: "",
                            "slider-color": "secondary",
                            color: "primary",
                            dark: ""
                          },
                          model: {
                            value: _vm.activeState2019,
                            callback: function($$v) {
                              _vm.activeState2019 = $$v
                            },
                            expression: "activeState2019"
                          }
                        },
                        [
                          _c("v-tab", [
                            _vm._v(_vm._s(_vm._f("cap")(_vm.$t("big"))))
                          ]),
                          _vm._v(" "),
                          _c("v-tab", [
                            _vm._v(_vm._s(_vm._f("cap")(_vm.$t("middle"))))
                          ]),
                          _vm._v(" "),
                          _c("v-tab", [
                            _vm._v(_vm._s(_vm._f("cap")(_vm.$t("mini"))))
                          ])
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _vm.activeState2019 == 1
                        ? _c(
                            "v-tabs",
                            {
                              staticClass: "elevation-0",
                              attrs: { centered: "", color: "transparent" },
                              model: {
                                value: _vm.botOrConseiller,
                                callback: function($$v) {
                                  _vm.botOrConseiller = $$v
                                },
                                expression: "botOrConseiller"
                              }
                            },
                            [
                              _c("v-tab", [
                                _vm._v(
                                  _vm._s(_vm._f("cap")(_vm.$t("conseiller")))
                                )
                              ]),
                              _vm._v(" "),
                              _c("v-tab", [_vm._v("bot")])
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _c("v-card", { attrs: { height: "550px" } }, [
                        _c("iframe", {
                          attrs: {
                            width: "100%",
                            height: "550",
                            src: _vm.iframeInnerSrc2019,
                            frameborder: "0"
                          }
                        })
                      ]),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "text-xs-right" },
                        [
                          _c(
                            "v-btn",
                            {
                              attrs: {
                                color: "primary",
                                flat: "",
                                dark: "",
                                block: _vm.$vuetify.breakpoint.xsOnly
                              },
                              nativeOn: {
                                click: function($event) {
                                  return _vm.resetOptions()
                                }
                              }
                            },
                            [
                              _vm._v(_vm._s(_vm.$t("cancel"))),
                              _c(
                                "v-icon",
                                {
                                  staticClass: "primary--text",
                                  attrs: { right: "" }
                                },
                                [_vm._v("settings_backup_restore")]
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "v-btn",
                            {
                              attrs: {
                                color: "primary",
                                block: _vm.$vuetify.breakpoint.xsOnly,
                                loading: _vm.loadingPost
                              },
                              nativeOn: {
                                click: function($event) {
                                  return _vm.postOptions()
                                }
                              }
                            },
                            [
                              _vm._v(_vm._s(_vm.$t("save"))),
                              _c("v-icon", { attrs: { dark: "", right: "" } }, [
                                _vm._v("save")
                              ])
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
      _vm._v(" "),
      _c("wz-dialog-infos", {
        attrs: {
          titleDialog: _vm.titleDialog,
          contentDialog: _vm.contentDialog
        },
        on: { fermeDialog: _vm.fermeDialogInfos }
      }),
      _vm._v(" "),
      _c(
        "v-dialog",
        {
          attrs: { persistent: "", lazy: "", "max-width": "290" },
          model: {
            value: _vm.showTp,
            callback: function($$v) {
              _vm.showTp = $$v
            },
            expression: "showTp"
          }
        },
        [
          _c(
            "v-time-picker",
            {
              attrs: {
                actions: "",
                scrollable: "",
                format: "24hr",
                max: _vm.allowed.hours.max,
                min: _vm.allowed.hours.min,
                color: "primary"
              },
              model: {
                value: _vm.daySelected[_vm.amOrPm][_vm.startOrEnd],
                callback: function($$v) {
                  _vm.$set(_vm.daySelected[_vm.amOrPm], _vm.startOrEnd, $$v)
                },
                expression: "daySelected[amOrPm][startOrEnd]"
              }
            },
            [
              _c("v-spacer"),
              _vm._v(" "),
              _c(
                "v-btn",
                {
                  attrs: { flat: "" },
                  on: {
                    click: function($event) {
                      _vm.showTp = false
                      _vm.daySelected[_vm.amOrPm][_vm.startOrEnd] = _vm.tmpHours
                    }
                  }
                },
                [_vm._v(_vm._s(_vm._f("cap")(_vm.$t("cancel"))))]
              ),
              _vm._v(" "),
              _c(
                "v-btn",
                {
                  attrs: { flat: "", color: "primary" },
                  on: {
                    click: function($event) {
                      _vm.showTp = false
                    }
                  }
                },
                [_vm._v(_vm._s(_vm._f("cap")(_vm.$t("submit"))))]
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-dialog",
        {
          attrs: { scrollable: "", persistent: "", width: "350px" },
          model: {
            value: _vm.showHours,
            callback: function($$v) {
              _vm.showHours = $$v
            },
            expression: "showHours"
          }
        },
        [
          _c(
            "v-card",
            [
              _c("v-card-title", { staticClass: "primary white--text" }, [
                _vm._v(_vm._s(_vm._f("cap")(_vm.$t("applySchedules"))))
              ]),
              _vm._v(" "),
              _c("v-divider"),
              _vm._v(" "),
              _c(
                "v-card-text",
                { staticStyle: { height: "400px" } },
                [
                  _c("v-select", {
                    attrs: {
                      items: _vm.days,
                      label: _vm.$t("applyHours"),
                      "return-object": ""
                    },
                    model: {
                      value: _vm.dayHours,
                      callback: function($$v) {
                        _vm.dayHours = $$v
                      },
                      expression: "dayHours"
                    }
                  }),
                  _vm._v(" "),
                  _c("v-data-table", {
                    staticClass: "elevation-1",
                    attrs: {
                      headers: _vm.headersDays,
                      items: _vm.days,
                      "item-key": "text",
                      "select-all": "primary",
                      "hide-actions": "",
                      "total-items": 7
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "headerCell",
                        fn: function(props) {
                          return [
                            _c("span", { staticClass: "subheading" }, [
                              _vm._v(_vm._s(props.header.text))
                            ])
                          ]
                        }
                      },
                      {
                        key: "items",
                        fn: function(props) {
                          return [
                            _c(
                              "td",
                              [
                                _c("v-checkbox", {
                                  staticClass: "primary--text",
                                  attrs: { "hide-details": "" },
                                  model: {
                                    value: props.selected,
                                    callback: function($$v) {
                                      _vm.$set(props, "selected", $$v)
                                    },
                                    expression: "props.selected"
                                  }
                                })
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c("td", [_vm._v(_vm._s(props.item.text))])
                          ]
                        }
                      }
                    ]),
                    model: {
                      value: _vm.daysTmp,
                      callback: function($$v) {
                        _vm.daysTmp = $$v
                      },
                      expression: "daysTmp"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c("v-divider"),
              _vm._v(" "),
              _c(
                "v-card-actions",
                [
                  _c("v-spacer"),
                  _vm._v(" "),
                  _c(
                    "v-btn",
                    {
                      attrs: { flat: "" },
                      on: {
                        click: function($event) {
                          _vm.showHours = false
                        }
                      }
                    },
                    [_vm._v(_vm._s(_vm.$t("cancel")))]
                  ),
                  _vm._v(" "),
                  _c(
                    "v-btn",
                    {
                      attrs: {
                        disabled: !_vm.daysTmp.length,
                        color: "primary",
                        flat: ""
                      },
                      on: {
                        click: function($event) {
                          return _vm.submitHours()
                        }
                      }
                    },
                    [_vm._v(_vm._s(_vm.$t("submit")))]
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-dialog",
        {
          attrs: { persistent: "", "max-width": "290" },
          model: {
            value: _vm.showDialogRule,
            callback: function($$v) {
              _vm.showDialogRule = $$v
            },
            expression: "showDialogRule"
          }
        },
        [
          _c(
            "v-card",
            [
              _c("v-card-title", { staticClass: "primary white--text" }, [
                _vm._v(_vm._s(_vm._f("cap")(_vm.$t("createRule"))))
              ]),
              _vm._v(" "),
              _c("v-card-text", [
                _c(
                  "form",
                  [
                    _c("v-select", {
                      directives: [
                        {
                          name: "validate",
                          rawName: "v-validate",
                          value: "required",
                          expression: "'required'"
                        }
                      ],
                      attrs: {
                        items: _vm.typeRules,
                        label: _vm.$t("ruleType"),
                        "return-object": "",
                        required: "",
                        "data-vv-name": "select",
                        error: _vm.wzErrors.has("select"),
                        "error-messages": _vm.wzErrors.collect("select")
                      },
                      model: {
                        value: _vm.ruleTmp.type,
                        callback: function($$v) {
                          _vm.$set(_vm.ruleTmp, "type", $$v)
                        },
                        expression: "ruleTmp.type"
                      }
                    }),
                    _vm._v(" "),
                    _c("v-text-field", {
                      directives: [
                        {
                          name: "validate",
                          rawName: "v-validate",
                          value: "required",
                          expression: "'required'"
                        }
                      ],
                      attrs: {
                        autofocus: "",
                        label: _vm.$t("ruleContent"),
                        required: "",
                        "data-vv-name": "ruleContentInput",
                        error: _vm.wzErrors.has("ruleContentInput"),
                        "error-messages": _vm.wzErrors.collect(
                          "ruleContentInput"
                        )
                      },
                      nativeOn: {
                        keyup: function($event) {
                          if (
                            !$event.type.indexOf("key") &&
                            _vm._k(
                              $event.keyCode,
                              "enter",
                              13,
                              $event.key,
                              "Enter"
                            )
                          ) {
                            return null
                          }
                          return _vm.submitRule()
                        }
                      },
                      model: {
                        value: _vm.ruleTmp.content,
                        callback: function($$v) {
                          _vm.$set(_vm.ruleTmp, "content", $$v)
                        },
                        expression: "ruleTmp.content"
                      }
                    })
                  ],
                  1
                )
              ]),
              _vm._v(" "),
              _c(
                "v-card-actions",
                [
                  _c("v-spacer"),
                  _vm._v(" "),
                  _c(
                    "v-btn",
                    {
                      attrs: { flat: "" },
                      on: {
                        click: function($event) {
                          _vm.showDialogRule = false
                        }
                      }
                    },
                    [_vm._v(_vm._s(_vm.$t("cancel")))]
                  ),
                  _vm._v(" "),
                  _c(
                    "v-btn",
                    {
                      attrs: {
                        color: "primary",
                        disabled: _vm.wzErrors.any(),
                        flat: ""
                      },
                      on: {
                        click: function($event) {
                          return _vm.submitRule()
                        }
                      }
                    },
                    [_vm._v(_vm._s(_vm.$t("submit")))]
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-4e3337cc", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4e3337cc","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/settings/Preview.vue
// module id = null
// module chunks = 